import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e8) { throw _e8; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e9) { didErr = true; err = _e9; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { c as e, _ as t, b as n, d as r, e as i, g as o, h as a, a as s, u as l, i as u, j as c, k as d } from "./_commonjsHelpers-b0e8727a.js";
import h, { Component as m, Fragment as f } from "react";
import { P as p } from "./index-f450c016.js";
import { b as g, t as v, a as b, c as _, d as y } from "./index-f217a905.js";
import { s as k } from "./style-inject.es-1f59c1d0.js";
import w from "dayjs";
import { g as x, a as E, b as M, c as S, d as T, e as C, i as D, s as A } from "./index-dc36b3f9.js";
import { t as O } from "./throttle-3ec7226e.js";
import F from "react-dom";
import R from "dayjs/plugin/relativeTime";
var N = e(function (e) {
  !function () {
    var t = {}.hasOwnProperty;

    function n() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];

        if (i) {
          var o = typeof i;
          if ("string" === o || "number" === o) e.push(i);else if (Array.isArray(i) && i.length) {
            var a = n.apply(null, i);
            a && e.push(a);
          } else if ("object" === o) for (var s in i) {
            t.call(i, s) && i[s] && e.push(s);
          }
        }
      }

      return e.join(" ");
    }

    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  }();
}),
    j = h.createContext(!1);
k(":root {\n  /* COLORS */\n  --timebar-main-background-color: #021236;\n  --timebar-main-border-color: #1e365a;\n  --timebar-secondary-background-color: #0b285f;\n  --timebar-ui-btn-color: #163f89;\n  --timebar-ui-btn-color-faded: rgba(22, 63, 137, 0.5);\n  --timebar-ui-btn-color-hover: #2d5295;\n  --timebar-main-background-color-white: rgba(79, 198, 215, 0.1);\n  --timebar-main-background-color-white-overlay: #1d2a4b;\n  --timebar-main-background-color-white-hover: rgba(79, 198, 215, 0.4);\n  --timebar-cta-btn-color: #46a4b9;\n  --timebar-cta-btn-hover: #58acbf;\n  --timebar-light-blue: #4fc6d7;\n  --timebar-white: #fff;\n\n  /* TYPE */\n  --timebar-font-family: 'Roboto', sans-serif;\n  --timebar-extra-large-font-size: 2rem;\n  --timebar-font-size: 1.3rem;\n  --timebar-font-weight: 500;\n  --timebar-small-font-size: 1.2rem;\n\n  /* OTHER */\n  --timebar-hover-transition: all 150ms linear;\n  --timebar-size: 7.2rem;\n}\n");
var P = {
  Timebar: "timebar-module_Timebar__3cQMO",
  uiButton: "timebar-module_uiButton__r7JmB",
  timeActions: "timebar-module_timeActions__2LFDm",
  timeRange: "timebar-module_timeRange__3I2q8",
  timeScale: "timebar-module_timeScale__3LqDh",
  timeRangeContainer: "timebar-module_timeRangeContainer__2VIuy",
  playbackActions: "timebar-module_playbackActions__3mgLx",
  bookmark: "timebar-module_bookmark__1EjmQ"
};
k(".timebar-module_Timebar__3cQMO {\n  width: 100%;\n  height: var(--timebar-size);\n  display: flex;\n  background: var(--timebar-main-background-color);\n  border-top: 1px solid var(--timebar-main-border-color);\n  color: var(--timebar-white);\n  font-family: var(--timebar-font-family);\n  font-size: var(--timebar-font-size);\n  font-weight: var(--timebar-font-weight);\n  box-sizing: content-box;\n}\n\n.timebar-module_uiButton__r7JmB {\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  cursor: pointer;\n  width: 3.6rem;\n  height: 3.6rem;\n  background-color: var(--timebar-ui-btn-color);\n  color: var(--timebar-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--timebar-hover-transition);\n}\n\n.timebar-module_uiButton__r7JmB:disabled {\n  cursor: not-allowed;\n}\n\n.timebar-module_uiButton__r7JmB:disabled svg {\n  opacity: 0.5;\n}\n\n.timebar-module_uiButton__r7JmB:hover,\n.timebar-module_uiButton__r7JmB:focus {\n  background-color: var(--timebar-ui-btn-color-hover);\n  outline: none;\n}\n\n/* TIME ACTIONS */\n\n.timebar-module_timeActions__2LFDm {\n  position: relative;\n  width: var(--timebar-size);\n  display: flex;\n  flex-wrap: wrap;\n  z-index: 1;\n}\n\n.timebar-module_timeRange__3I2q8 {\n  border-right: 0.1rem solid var(--timebar-main-background-color);\n}\n\n.timebar-module_timeScale__3LqDh {\n  display: flex;\n}\n\n.timebar-module_timeScale__3LqDh .timebar-module_uiButton__r7JmB {\n  border-top: 0.1rem solid var(--timebar-main-background-color);\n  height: 3.5rem;\n}\n\n.timebar-module_timeRangeContainer__2VIuy {\n  position: relative;\n}\n\n@media only screen and (max-width: 72rem) {\n  :root {\n    --timebar-size: 6rem;\n  }\n\n  .timebar-module_playbackActions__3mgLx,\n  .timebar-module_bookmark__1EjmQ,\n  .timebar-module_timeScale__3LqDh {\n    display: none;\n  }\n\n  .timebar-module_timeRange__3I2q8 {\n    width: var(--timebar-size);\n    height: var(--timebar-size);\n  }\n}\n");
var z = "date-selector-module_DateSelector__1KybU",
    U = "date-selector-module_arrowButton__3lvh8",
    q = "date-selector-module_value__3t31b";

function I() {
  return (I = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

k(".date-selector-module_DateSelector__1KybU {\n  /* font-family: var(--timebar-font-family); */\n  display: flex;\n  flex-direction: column;\n  width: 4.2rem;\n  margin-right: 1rem;\n}\n\n.date-selector-module_arrowButton__3lvh8 {\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  cursor: pointer;\n  height: 2.4rem;\n  background: transparent;\n  color: var(--timebar-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--timebar-hover-transition);\n}\n\n.date-selector-module_arrowButton__3lvh8:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.date-selector-module_arrowButton__3lvh8:hover,\n.date-selector-module_arrowButton__3lvh8:focus {\n  background: rgba(255, 255, 255, 0.05);\n  outline: none;\n}\n\n.date-selector-module_value__3t31b {\n  display: flex;\n  height: 3.4rem;\n  align-items: center;\n  justify-content: center;\n  background: var(--timebar-secondary-background-color);\n  color: var(--timebar-light-blue);\n  text-transform: uppercase;\n}\n");

var L = h.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  d: "M1 6l4-4 4 4",
  fill: "none"
}),
    H = function H(e) {
  return h.createElement("svg", I({
    width: 10,
    height: 7
  }, e), L);
};

function V() {
  return (V = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var X = h.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  d: "M1 1l4 4 4-4",
  fill: "none"
}),
    B = function B(e) {
  return h.createElement("svg", V({
    width: 10,
    height: 7
  }, e), X);
},
    W = function (e) {
  function l() {
    var e, t;
    n(this, l);

    for (var s = arguments.length, u = new Array(s), c = 0; c < s; c++) {
      u[c] = arguments[c];
    }

    return t = r(this, (e = i(l)).call.apply(e, [this].concat(u))), o(a(t), "pressing", 0), o(a(t), "pressingInterval", null), o(a(t), "pressingTimeout", null), o(a(t), "startTimeout", function () {
      t.pressingInterval = window.setInterval(t.onInterval, 80);
    }), o(a(t), "onInterval", function () {
      (0, t.props.onChange)(t.pressing);
    }), o(a(t), "onMouseUp", function () {
      t.clear(), t.pressing = 0;
    }), t;
  }

  return t(l, m), s(l, [{
    key: "onMouseDown",
    value: function value(e) {
      this.clear();
      var t = this.props.onChange;
      this.pressing = e, t(this.pressing), this.pressingTimeout = window.setTimeout(this.startTimeout, 800), window.addEventListener("mouseup", this.onMouseUp);
    }
  }, {
    key: "clear",
    value: function value() {
      window.clearInterval(this.pressingInterval), window.clearTimeout(this.pressingTimeout), window.removeEventListener("mouseup", this.onMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.clear();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = (t.onChange, t.value),
          r = t.canIncrement,
          i = t.canDecrement;
      return h.createElement("div", {
        className: z
      }, h.createElement("button", {
        type: "button",
        className: U,
        disabled: !r,
        onMouseDown: function onMouseDown() {
          e.onMouseDown(1);
        }
      }, h.createElement(H, null)), h.createElement("span", {
        className: q
      }, n), h.createElement("button", {
        type: "button",
        className: U,
        disabled: !i,
        onMouseDown: function onMouseDown() {
          e.onMouseDown(-1);
        }
      }, h.createElement(B, null)));
    }
  }]), l;
}();

W.propTypes = {
  onChange: p.func.isRequired,
  value: p.oneOfType([p.string, p.number]).isRequired,
  canIncrement: p.bool.isRequired,
  canDecrement: p.bool.isRequired
};
var Y = "timerange-selector-module_TimeRangeSelector__3T0N9",
    G = "timerange-selector-module_veil__1W4As",
    Z = "timerange-selector-module_inner__lI2l-",
    $ = "timerange-selector-module_selectorsContainer__XGQac",
    J = "timerange-selector-module_selectorGroup__21lwN",
    K = "timerange-selector-module_selectorLabel__3CgWu",
    Q = "timerange-selector-module_actions__28ixU",
    ee = "timerange-selector-module_cta__1IDbd",
    te = "timerange-selector-module_secondary__14OVp",
    ne = "timerange-selector-module_errorMessage__2VKEP";
k(".timerange-selector-module_TimeRangeSelector__3T0N9 {\n  position: absolute;\n  bottom: var(--timebar-size);\n  left: 0;\n  width: 46rem;\n  background: var(--timebar-main-background-color);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-sizing: border-box;\n  z-index: 0;\n  box-shadow: 0 0 28px 5px rgba(0, 0, 0, 0.8);\n}\n\n.timerange-selector-module_veil__1W4As {\n  content: '';\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background: var(--timebar-main-background-color);\n  opacity: 0.7;\n  z-index: -1;\n}\n\n.timerange-selector-module_inner__lI2l- {\n  padding: 3.5rem 3rem 3rem;\n}\n\nh2 {\n  font-size: var(--timebar-extra-large-font-size);\n  line-height: var(--timebar-extra-large-font-size);\n  margin: 0 0 2rem;\n  letter-spacing: 0.1rem;\n}\n\n.timerange-selector-module_selectorsContainer__XGQac {\n  display: flex;\n  margin-bottom: 0.6rem;\n}\n\n.timerange-selector-module_selectorGroup__21lwN {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\n.timerange-selector-module_selectorLabel__3CgWu {\n  width: 100%;\n}\n\n.timerange-selector-module_actions__28ixU {\n  display: flex;\n  justify-content: space-between;\n}\n\n.timerange-selector-module_cta__1IDbd {\n  display: block;\n  border: none;\n  padding: 0;\n  border-radius: 0;\n  cursor: pointer;\n  width: 15rem;\n  height: 3.6rem;\n  background: var(--timebar-cta-btn-color);\n  color: var(--timebar-white);\n  font-size: var(--timebar-font-size);\n  transition: var(--timebar-hover-transition);\n}\n\n.timerange-selector-module_cta__1IDbd:hover,\n.timerange-selector-module_cta__1IDbd:focus {\n  background: var(--timebar-cta-btn-hover);\n  outline: none;\n}\n\n.timerange-selector-module_secondary__14OVp {\n  background: transparent;\n  border: 0.1rem solid var(--timebar-cta-btn-color);\n}\n\n.timerange-selector-module_secondary__14OVp:hover,\n.timerange-selector-module_secondary__14OVp:focus {\n  background: rgba(255, 255, 255, 0.05);\n  outline: none;\n}\n\n.timerange-selector-module_errorMessage__2VKEP {\n  display: block;\n  opacity: 0.5;\n  margin-bottom: 1.2rem;\n  min-height: 2rem;\n  line-height: 2rem;\n}\n\n@media only screen and (max-width: 540px) {\n  .timerange-selector-module_TimeRangeSelector__3T0N9 {\n    width: 100vw;\n    position: fixed;\n    bottom: var(--timebar-size);\n  }\n}\n\n@media only screen and (max-width: 380px) {\n  .timerange-selector-module_selectorsContainer__XGQac {\n    flex-direction: column;\n  }\n\n  .timerange-selector-module_selectorGroup__21lwN {\n    align-items: center;\n  }\n\n  .timerange-selector-module_selectorGroup__21lwN:first-child {\n    margin-bottom: 2rem;\n  }\n\n  .timerange-selector-module_selectorLabel__3CgWu {\n    width: 6rem;\n  }\n\n  .timerange-selector-module_secondary__14OVp {\n    display: none;\n  }\n}\n");

var re = 864e5 - 1,
    ie = function (e) {
  function l(e) {
    var t;
    n(this, l), t = r(this, i(l).call(this, e)), o(a(t), "last30days", function () {
      var e = t.props,
          n = e.absoluteEnd;
      (0, e.onSubmit)(w(n).subtract(30, "day").toISOString(), n);
    });
    var s = e.start,
        u = e.end,
        c = e.absoluteStart,
        d = e.absoluteEnd;
    return t.state = {
      startCanIncrement: s < u,
      startCanDecrement: s > c,
      endCanIncrement: x(u) + re < x(d),
      endCanDecrement: u > s
    }, t;
  }

  return t(l, m), s(l, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props,
          t = e.start,
          n = e.end;
      this.setState({
        start: t,
        end: n
      });
    }
  }, {
    key: "submit",
    value: function value(e, t) {
      (0, this.props.onSubmit)(w(e).startOf("day").toISOString(), w(t).startOf("day").toISOString());
    }
  }, {
    key: "setUnit",
    value: function value(e, t, n, r) {
      var i = this.state[e],
          o = w(i).add(r, n),
          a = t[e],
          s = o.toDate().getTime();
      s = Math.min(a.max, Math.max(a.min, s)), "start" === e ? this.setState({
        start: new Date(s),
        startCanIncrement: s !== a.max,
        startCanDecrement: s !== a.min,
        endCanDecrement: s !== a.max
      }) : this.setState({
        end: new Date(s),
        endCanIncrement: s !== a.max,
        endCanDecrement: s !== a.min,
        startCanIncrement: s !== a.min
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.state,
          n = t.start,
          r = t.end,
          i = t.startCanIncrement,
          o = t.startCanDecrement,
          a = t.endCanIncrement,
          s = t.endCanDecrement,
          l = this.props,
          u = l.absoluteStart,
          c = l.absoluteEnd;
      if (void 0 === n) return null;
      var d = {
        start: {
          min: x(u),
          max: x(r) - re
        },
        end: {
          min: x(n) + re,
          max: x(c)
        }
      },
          m = w(n),
          f = w(r),
          p = "";
      return o || (p = "Your start date is the earliest date with data available"), a || (p = "Your end date is the latest date with data available"), i || s || (p = "Your start and end date must be at least one day apart"), o || a || (p = "Your time range is the maximum range with data available"), h.createElement("div", {
        className: Y
      }, h.createElement("div", {
        className: G,
        onClick: this.props.onDiscard
      }), h.createElement("div", {
        className: Z
      }, h.createElement("h2", null, "Select a time range"), h.createElement("div", {
        className: $
      }, h.createElement("div", {
        className: J
      }, h.createElement("span", {
        className: K
      }, "START"), h.createElement(W, {
        canIncrement: i,
        canDecrement: o,
        onChange: function onChange(t) {
          e.setUnit("start", d, "day", t);
        },
        value: m.date()
      }), h.createElement(W, {
        canIncrement: i,
        canDecrement: o,
        onChange: function onChange(t) {
          e.setUnit("start", d, "month", t);
        },
        value: m.format("MMM")
      }), h.createElement(W, {
        canIncrement: i,
        canDecrement: o,
        onChange: function onChange(t) {
          e.setUnit("start", d, "year", t);
        },
        value: m.year()
      })), h.createElement("div", {
        className: J
      }, h.createElement("span", {
        className: K
      }, "END"), h.createElement(W, {
        canIncrement: a,
        canDecrement: s,
        onChange: function onChange(t) {
          e.setUnit("end", d, "day", t);
        },
        value: f.date()
      }), h.createElement(W, {
        canIncrement: a,
        canDecrement: s,
        onChange: function onChange(t) {
          e.setUnit("end", d, "month", t);
        },
        value: f.format("MMM")
      }), h.createElement(W, {
        canIncrement: a,
        canDecrement: s,
        onChange: function onChange(t) {
          e.setUnit("end", d, "year", t);
        },
        value: f.year()
      }))), h.createElement("span", {
        className: ne
      }, p), h.createElement("div", {
        className: Q
      }, h.createElement("button", {
        type: "button",
        className: N(ee, te),
        onClick: this.last30days
      }, "LAST 30 DAYS"), h.createElement("button", {
        type: "button",
        className: ee,
        onClick: function onClick() {
          e.submit(n, r);
        }
      }, "DONE"))));
    }
  }]), l;
}();

function oe(e, t) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(e);
      break;

    default:
      this.range(t).domain(e);
  }

  return this;
}

ie.propTypes = {
  onSubmit: p.func.isRequired,
  start: p.string.isRequired,
  end: p.string.isRequired,
  absoluteStart: p.string.isRequired,
  absoluteEnd: p.string.isRequired,
  onDiscard: p.func.isRequired
};

function ae() {}

function se(e, t) {
  var n = new ae();
  if (e instanceof ae) e.each(function (e, t) {
    n.set(t, e);
  });else if (Array.isArray(e)) {
    var r,
        i = -1,
        o = e.length;
    if (null == t) for (; ++i < o;) {
      n.set(i, e[i]);
    } else for (; ++i < o;) {
      n.set(t(r = e[i], i, e), r);
    }
  } else if (e) for (var a in e) {
    n.set(a, e[a]);
  }
  return n;
}

function le() {}

ae.prototype = se.prototype = {
  constructor: ae,
  has: function has(e) {
    return "$" + e in this;
  },
  get: function get(e) {
    return this["$" + e];
  },
  set: function set(e, t) {
    return this["$" + e] = t, this;
  },
  remove: function remove(e) {
    var t = "$" + e;
    return t in this && delete this[t];
  },
  clear: function clear() {
    for (var e in this) {
      "$" === e[0] && delete this[e];
    }
  },
  keys: function keys() {
    var e = [];

    for (var t in this) {
      "$" === t[0] && e.push(t.slice(1));
    }

    return e;
  },
  values: function values() {
    var e = [];

    for (var t in this) {
      "$" === t[0] && e.push(this[t]);
    }

    return e;
  },
  entries: function entries() {
    var e = [];

    for (var t in this) {
      "$" === t[0] && e.push({
        key: t.slice(1),
        value: this[t]
      });
    }

    return e;
  },
  size: function size() {
    var e = 0;

    for (var t in this) {
      "$" === t[0] && ++e;
    }

    return e;
  },
  empty: function empty() {
    for (var e in this) {
      if ("$" === e[0]) return !1;
    }

    return !0;
  },
  each: function each(e) {
    for (var t in this) {
      "$" === t[0] && e(this[t], t.slice(1), this);
    }
  }
};
var ue = se.prototype;

le.prototype = function (e, t) {
  var n = new le();
  if (e instanceof le) e.each(function (e) {
    n.add(e);
  });else if (e) {
    var r = -1,
        i = e.length;
    if (null == t) for (; ++r < i;) {
      n.add(e[r]);
    } else for (; ++r < i;) {
      n.add(t(e[r], r, e));
    }
  }
  return n;
}.prototype = {
  constructor: le,
  has: ue.has,
  add: function add(e) {
    return this["$" + (e += "")] = e, this;
  },
  remove: ue.remove,
  clear: ue.clear,
  values: ue.keys,
  size: ue.size,
  empty: ue.empty,
  each: ue.each
};

var ce = Array.prototype,
    de = ce.map,
    he = ce.slice;

function me(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}

function fe(e, t) {
  var n = Object.create(e.prototype);

  for (var r in t) {
    n[r] = t[r];
  }

  return n;
}

function pe() {}

var ge = "\\s*([+-]?\\d+)\\s*",
    ve = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    be = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    _e = /^#([0-9a-f]{3,8})$/,
    ye = new RegExp("^rgb\\(" + [ge, ge, ge] + "\\)$"),
    ke = new RegExp("^rgb\\(" + [be, be, be] + "\\)$"),
    we = new RegExp("^rgba\\(" + [ge, ge, ge, ve] + "\\)$"),
    xe = new RegExp("^rgba\\(" + [be, be, be, ve] + "\\)$"),
    Ee = new RegExp("^hsl\\(" + [ve, be, be] + "\\)$"),
    Me = new RegExp("^hsla\\(" + [ve, be, be, ve] + "\\)$"),
    Se = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};

function Te() {
  return this.rgb().formatHex();
}

function Ce() {
  return this.rgb().formatRgb();
}

function De(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = _e.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), 6 === n ? Ae(t) : 3 === n ? new Ne(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, (15 & t) << 4 | 15 & t, 1) : 8 === n ? new Ne(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (255 & t) / 255) : 4 === n ? new Ne(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, ((15 & t) << 4 | 15 & t) / 255) : null) : (t = ye.exec(e)) ? new Ne(t[1], t[2], t[3], 1) : (t = ke.exec(e)) ? new Ne(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, 1) : (t = we.exec(e)) ? Oe(t[1], t[2], t[3], t[4]) : (t = xe.exec(e)) ? Oe(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, t[4]) : (t = Ee.exec(e)) ? Ue(t[1], t[2] / 100, t[3] / 100, 1) : (t = Me.exec(e)) ? Ue(t[1], t[2] / 100, t[3] / 100, t[4]) : Se.hasOwnProperty(e) ? Ae(Se[e]) : "transparent" === e ? new Ne(NaN, NaN, NaN, 0) : null;
}

function Ae(e) {
  return new Ne(e >> 16 & 255, e >> 8 & 255, 255 & e, 1);
}

function Oe(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Ne(e, t, n, r);
}

function Fe(e) {
  return e instanceof pe || (e = De(e)), e ? new Ne((e = e.rgb()).r, e.g, e.b, e.opacity) : new Ne();
}

function Re(e, t, n, r) {
  return 1 === arguments.length ? Fe(e) : new Ne(e, t, n, null == r ? 1 : r);
}

function Ne(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}

function je() {
  return "#" + ze(this.r) + ze(this.g) + ze(this.b);
}

function Pe() {
  var e = this.opacity;
  return (1 === (e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === e ? ")" : ", " + e + ")");
}

function ze(e) {
  return ((e = Math.max(0, Math.min(255, Math.round(e) || 0))) < 16 ? "0" : "") + e.toString(16);
}

function Ue(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Ie(e, t, n, r);
}

function qe(e) {
  if (e instanceof Ie) return new Ie(e.h, e.s, e.l, e.opacity);
  if (e instanceof pe || (e = De(e)), !e) return new Ie();
  if (e instanceof Ie) return e;
  var t = (e = e.rgb()).r / 255,
      n = e.g / 255,
      r = e.b / 255,
      i = Math.min(t, n, r),
      o = Math.max(t, n, r),
      a = NaN,
      s = o - i,
      l = (o + i) / 2;
  return s ? (a = t === o ? (n - r) / s + 6 * (n < r) : n === o ? (r - t) / s + 2 : (t - n) / s + 4, s /= l < .5 ? o + i : 2 - o - i, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Ie(a, s, l, e.opacity);
}

function Ie(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}

function Le(e, t, n) {
  return 255 * (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t);
}

me(pe, De, {
  copy: function copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: Te,
  formatHex: Te,
  formatHsl: function formatHsl() {
    return qe(this).formatHsl();
  },
  formatRgb: Ce,
  toString: Ce
}), me(Ne, Re, fe(pe, {
  brighter: function brighter(e) {
    return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new Ne(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? .7 : Math.pow(.7, e), new Ne(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: je,
  formatHex: je,
  formatRgb: Pe,
  toString: Pe
})), me(Ie, function (e, t, n, r) {
  return 1 === arguments.length ? qe(e) : new Ie(e, t, n, null == r ? 1 : r);
}, fe(pe, {
  brighter: function brighter(e) {
    return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new Ie(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? .7 : Math.pow(.7, e), new Ie(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function rgb() {
    var e = this.h % 360 + 360 * (this.h < 0),
        t = isNaN(e) || isNaN(this.s) ? 0 : this.s,
        n = this.l,
        r = n + (n < .5 ? n : 1 - n) * t,
        i = 2 * n - r;
    return new Ne(Le(e >= 240 ? e - 240 : e + 120, i, r), Le(e, i, r), Le(e < 120 ? e + 240 : e - 120, i, r), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var e = this.opacity;
    return (1 === (e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === e ? ")" : ", " + e + ")");
  }
}));
var He = Math.PI / 180,
    Ve = 180 / Math.PI,
    Xe = .96422,
    Be = 1,
    We = .82521,
    Ye = 4 / 29,
    Ge = 6 / 29,
    Ze = 3 * Ge * Ge,
    $e = Ge * Ge * Ge;

function Je(e) {
  if (e instanceof Ke) return new Ke(e.l, e.a, e.b, e.opacity);
  if (e instanceof rt) return it(e);
  e instanceof Ne || (e = Fe(e));
  var t,
      n,
      r = nt(e.r),
      i = nt(e.g),
      o = nt(e.b),
      a = Qe((.2225045 * r + .7168786 * i + .0606169 * o) / Be);
  return r === i && i === o ? t = n = a : (t = Qe((.4360747 * r + .3850649 * i + .1430804 * o) / Xe), n = Qe((.0139322 * r + .0971045 * i + .7141733 * o) / We)), new Ke(116 * a - 16, 500 * (t - a), 200 * (a - n), e.opacity);
}

function Ke(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}

function Qe(e) {
  return e > $e ? Math.pow(e, 1 / 3) : e / Ze + Ye;
}

function et(e) {
  return e > Ge ? e * e * e : Ze * (e - Ye);
}

function tt(e) {
  return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
}

function nt(e) {
  return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
}

function rt(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}

function it(e) {
  if (isNaN(e.h)) return new Ke(e.l, 0, 0, e.opacity);
  var t = e.h * He;
  return new Ke(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
}

me(Ke, function (e, t, n, r) {
  return 1 === arguments.length ? Je(e) : new Ke(e, t, n, null == r ? 1 : r);
}, fe(pe, {
  brighter: function brighter(e) {
    return new Ke(this.l + 18 * (null == e ? 1 : e), this.a, this.b, this.opacity);
  },
  darker: function darker(e) {
    return new Ke(this.l - 18 * (null == e ? 1 : e), this.a, this.b, this.opacity);
  },
  rgb: function rgb() {
    var e = (this.l + 16) / 116,
        t = isNaN(this.a) ? e : e + this.a / 500,
        n = isNaN(this.b) ? e : e - this.b / 200;
    return new Ne(tt(3.1338561 * (t = Xe * et(t)) - 1.6168667 * (e = Be * et(e)) - .4906146 * (n = We * et(n))), tt(-.9787684 * t + 1.9161415 * e + .033454 * n), tt(.0719453 * t - .2289914 * e + 1.4052427 * n), this.opacity);
  }
})), me(rt, function (e, t, n, r) {
  return 1 === arguments.length ? function (e) {
    if (e instanceof rt) return new rt(e.h, e.c, e.l, e.opacity);
    if (e instanceof Ke || (e = Je(e)), 0 === e.a && 0 === e.b) return new rt(NaN, 0 < e.l && e.l < 100 ? 0 : NaN, e.l, e.opacity);
    var t = Math.atan2(e.b, e.a) * Ve;
    return new rt(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
  }(e) : new rt(e, t, n, null == r ? 1 : r);
}, fe(pe, {
  brighter: function brighter(e) {
    return new rt(this.h, this.c, this.l + 18 * (null == e ? 1 : e), this.opacity);
  },
  darker: function darker(e) {
    return new rt(this.h, this.c, this.l - 18 * (null == e ? 1 : e), this.opacity);
  },
  rgb: function rgb() {
    return it(this).rgb();
  }
}));
var ot = -.14861,
    at = 1.78277,
    st = -.29227,
    lt = -.90649,
    ut = 1.97294,
    ct = ut * lt,
    dt = ut * at,
    ht = at * st - lt * ot;

function mt(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}

function ft(e) {
  return function () {
    return e;
  };
}

function pt(e) {
  return 1 == (e = +e) ? gt : function (t, n) {
    return n - t ? function (e, t, n) {
      return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function (r) {
        return Math.pow(e + r * t, n);
      };
    }(t, n, e) : ft(isNaN(t) ? n : t);
  };
}

function gt(e, t) {
  var n = t - e;
  return n ? function (e, t) {
    return function (n) {
      return e + n * t;
    };
  }(e, n) : ft(isNaN(e) ? t : e);
}

me(mt, function (e, t, n, r) {
  return 1 === arguments.length ? function (e) {
    if (e instanceof mt) return new mt(e.h, e.s, e.l, e.opacity);
    e instanceof Ne || (e = Fe(e));
    var t = e.r / 255,
        n = e.g / 255,
        r = e.b / 255,
        i = (ht * r + ct * t - dt * n) / (ht + ct - dt),
        o = r - i,
        a = (ut * (n - i) - st * o) / lt,
        s = Math.sqrt(a * a + o * o) / (ut * i * (1 - i)),
        l = s ? Math.atan2(a, o) * Ve - 120 : NaN;
    return new mt(l < 0 ? l + 360 : l, s, i, e.opacity);
  }(e) : new mt(e, t, n, null == r ? 1 : r);
}, fe(pe, {
  brighter: function brighter(e) {
    return e = null == e ? 1 / .7 : Math.pow(1 / .7, e), new mt(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? .7 : Math.pow(.7, e), new mt(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * He,
        t = +this.l,
        n = isNaN(this.s) ? 0 : this.s * t * (1 - t),
        r = Math.cos(e),
        i = Math.sin(e);
    return new Ne(255 * (t + n * (ot * r + at * i)), 255 * (t + n * (st * r + lt * i)), 255 * (t + n * (ut * r)), this.opacity);
  }
}));

var vt = function e(t) {
  var n = pt(t);

  function r(e, t) {
    var r = n((e = Re(e)).r, (t = Re(t)).r),
        i = n(e.g, t.g),
        o = n(e.b, t.b),
        a = gt(e.opacity, t.opacity);
    return function (t) {
      return e.r = r(t), e.g = i(t), e.b = o(t), e.opacity = a(t), e + "";
    };
  }

  return r.gamma = e, r;
}(1);

function bt(e, t) {
  return e = +e, t = +t, function (n) {
    return e * (1 - n) + t * n;
  };
}

var _t = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    yt = new RegExp(_t.source, "g");

function kt(e, t) {
  var n,
      r,
      i = typeof t;
  return null == t || "boolean" === i ? ft(t) : ("number" === i ? bt : "string" === i ? (n = De(t)) ? (t = n, vt) : function (e, t) {
    var n,
        r,
        i,
        o = _t.lastIndex = yt.lastIndex = 0,
        a = -1,
        s = [],
        l = [];

    for (e += "", t += ""; (n = _t.exec(e)) && (r = yt.exec(t));) {
      (i = r.index) > o && (i = t.slice(o, i), s[a] ? s[a] += i : s[++a] = i), (n = n[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, l.push({
        i: a,
        x: bt(n, r)
      })), o = yt.lastIndex;
    }

    return o < t.length && (i = t.slice(o), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? function (e) {
      return function (t) {
        return e(t) + "";
      };
    }(l[0].x) : function (e) {
      return function () {
        return e;
      };
    }(t) : (t = l.length, function (e) {
      for (var n, r = 0; r < t; ++r) {
        s[(n = l[r]).i] = n.x(e);
      }

      return s.join("");
    });
  } : t instanceof De ? vt : t instanceof Date ? function (e, t) {
    var n = new Date();
    return e = +e, t = +t, function (r) {
      return n.setTime(e * (1 - r) + t * r), n;
    };
  } : (r = t, !ArrayBuffer.isView(r) || r instanceof DataView ? Array.isArray(t) ? function (e, t) {
    var n,
        r = t ? t.length : 0,
        i = e ? Math.min(r, e.length) : 0,
        o = new Array(i),
        a = new Array(r);

    for (n = 0; n < i; ++n) {
      o[n] = kt(e[n], t[n]);
    }

    for (; n < r; ++n) {
      a[n] = t[n];
    }

    return function (e) {
      for (n = 0; n < i; ++n) {
        a[n] = o[n](e);
      }

      return a;
    };
  } : "function" != typeof t.valueOf && "function" != typeof t.toString || isNaN(t) ? function (e, t) {
    var n,
        r = {},
        i = {};

    for (n in null !== e && "object" == typeof e || (e = {}), null !== t && "object" == typeof t || (t = {}), t) {
      n in e ? r[n] = kt(e[n], t[n]) : i[n] = t[n];
    }

    return function (e) {
      for (n in r) {
        i[n] = r[n](e);
      }

      return i;
    };
  } : bt : function (e, t) {
    t || (t = []);
    var n,
        r = e ? Math.min(t.length, e.length) : 0,
        i = t.slice();
    return function (o) {
      for (n = 0; n < r; ++n) {
        i[n] = e[n] * (1 - o) + t[n] * o;
      }

      return i;
    };
  }))(e, t);
}

function wt(e, t) {
  return e = +e, t = +t, function (n) {
    return Math.round(e * (1 - n) + t * n);
  };
}

function xt(e) {
  return +e;
}

var Et = [0, 1];

function Mt(e) {
  return e;
}

function St(e, t) {
  return (t -= e = +e) ? function (n) {
    return (n - e) / t;
  } : (n = isNaN(t) ? NaN : .5, function () {
    return n;
  });
  var n;
}

function Tt(e) {
  var t,
      n = e[0],
      r = e[e.length - 1];
  return n > r && (t = n, n = r, r = t), function (e) {
    return Math.max(n, Math.min(r, e));
  };
}

function Ct(e, t, n) {
  var r = e[0],
      i = e[1],
      o = t[0],
      a = t[1];
  return i < r ? (r = St(i, r), o = n(a, o)) : (r = St(r, i), o = n(o, a)), function (e) {
    return o(r(e));
  };
}

function Dt(e, t, n) {
  var r = Math.min(e.length, t.length) - 1,
      i = new Array(r),
      o = new Array(r),
      a = -1;

  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r;) {
    i[a] = St(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  }

  return function (t) {
    var n = g(e, t, 1, r) - 1;
    return o[n](i[n](t));
  };
}

function At(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}

function Ot(e, t) {
  return function () {
    var e,
        t,
        n,
        r,
        i,
        o,
        a = Et,
        s = Et,
        l = kt,
        u = Mt;

    function c() {
      return r = Math.min(a.length, s.length) > 2 ? Dt : Ct, i = o = null, d;
    }

    function d(t) {
      return isNaN(t = +t) ? n : (i || (i = r(a.map(e), s, l)))(e(u(t)));
    }

    return d.invert = function (n) {
      return u(t((o || (o = r(s, a.map(e), bt)))(n)));
    }, d.domain = function (e) {
      return arguments.length ? (a = de.call(e, xt), u === Mt || (u = Tt(a)), c()) : a.slice();
    }, d.range = function (e) {
      return arguments.length ? (s = he.call(e), c()) : s.slice();
    }, d.rangeRound = function (e) {
      return s = he.call(e), l = wt, c();
    }, d.clamp = function (e) {
      return arguments.length ? (u = e ? Tt(a) : Mt, d) : u !== Mt;
    }, d.interpolate = function (e) {
      return arguments.length ? (l = e, c()) : l;
    }, d.unknown = function (e) {
      return arguments.length ? (n = e, d) : n;
    }, function (n, r) {
      return e = n, t = r, c();
    };
  }()(e, t);
}

function Ft(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n,
      r = e.slice(0, n);
  return [r.length > 1 ? r[0] + r.slice(2) : r, +e.slice(n + 1)];
}

function Rt(e) {
  return (e = Ft(Math.abs(e))) ? e[1] : NaN;
}

var Nt,
    jt = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function Pt(e) {
  if (!(t = jt.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new zt({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}

function zt(e) {
  this.fill = void 0 === e.fill ? " " : e.fill + "", this.align = void 0 === e.align ? ">" : e.align + "", this.sign = void 0 === e.sign ? "-" : e.sign + "", this.symbol = void 0 === e.symbol ? "" : e.symbol + "", this.zero = !!e.zero, this.width = void 0 === e.width ? void 0 : +e.width, this.comma = !!e.comma, this.precision = void 0 === e.precision ? void 0 : +e.precision, this.trim = !!e.trim, this.type = void 0 === e.type ? "" : e.type + "";
}

function Ut(e, t) {
  var n = Ft(e, t);
  if (!n) return e + "";
  var r = n[0],
      i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}

Pt.prototype = zt.prototype, zt.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
var qt = {
  "%": function _(e, t) {
    return (100 * e).toFixed(t);
  },
  b: function b(e) {
    return Math.round(e).toString(2);
  },
  c: function c(e) {
    return e + "";
  },
  d: function d(e) {
    return Math.round(e).toString(10);
  },
  e: function e(_e2, t) {
    return _e2.toExponential(t);
  },
  f: function f(e, t) {
    return e.toFixed(t);
  },
  g: function g(e, t) {
    return e.toPrecision(t);
  },
  o: function o(e) {
    return Math.round(e).toString(8);
  },
  p: function p(e, t) {
    return Ut(100 * e, t);
  },
  r: Ut,
  s: function s(e, t) {
    var n = Ft(e, t);
    if (!n) return e + "";
    var r = n[0],
        i = n[1],
        o = i - (Nt = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
        a = r.length;
    return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Ft(e, Math.max(0, t + o - 1))[0];
  },
  X: function X(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function x(e) {
    return Math.round(e).toString(16);
  }
};

function It(e) {
  return e;
}

var Lt,
    Ht,
    Vt,
    Xt = Array.prototype.map,
    Bt = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function Wt(e) {
  var t,
      n,
      r = void 0 === e.grouping || void 0 === e.thousands ? It : (t = Xt.call(e.grouping, Number), n = e.thousands + "", function (e, r) {
    for (var i = e.length, o = [], a = 0, s = t[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(e.substring(i -= s, i + s)), !((l += s + 1) > r));) {
      s = t[a = (a + 1) % t.length];
    }

    return o.reverse().join(n);
  }),
      i = void 0 === e.currency ? "" : e.currency[0] + "",
      o = void 0 === e.currency ? "" : e.currency[1] + "",
      a = void 0 === e.decimal ? "." : e.decimal + "",
      s = void 0 === e.numerals ? It : function (e) {
    return function (t) {
      return t.replace(/[0-9]/g, function (t) {
        return e[+t];
      });
    };
  }(Xt.call(e.numerals, String)),
      l = void 0 === e.percent ? "%" : e.percent + "",
      u = void 0 === e.minus ? "-" : e.minus + "",
      c = void 0 === e.nan ? "NaN" : e.nan + "";

  function d(e) {
    var t = (e = Pt(e)).fill,
        n = e.align,
        d = e.sign,
        h = e.symbol,
        m = e.zero,
        f = e.width,
        p = e.comma,
        g = e.precision,
        v = e.trim,
        b = e.type;
    "n" === b ? (p = !0, b = "g") : qt[b] || (void 0 === g && (g = 12), v = !0, b = "g"), (m || "0" === t && "=" === n) && (m = !0, t = "0", n = "=");

    var _ = "$" === h ? i : "#" === h && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "",
        y = "$" === h ? o : /[%p]/.test(b) ? l : "",
        k = qt[b],
        w = /[defgprs%]/.test(b);

    function x(e) {
      var i,
          o,
          l,
          h = _,
          x = y;
      if ("c" === b) x = k(e) + x, e = "";else {
        var E = (e = +e) < 0;
        if (e = isNaN(e) ? c : k(Math.abs(e), g), v && (e = function (e) {
          e: for (var t, n = e.length, r = 1, i = -1; r < n; ++r) {
            switch (e[r]) {
              case ".":
                i = t = r;
                break;

              case "0":
                0 === i && (i = r), t = r;
                break;

              default:
                if (!+e[r]) break e;
                i > 0 && (i = 0);
            }
          }

          return i > 0 ? e.slice(0, i) + e.slice(t + 1) : e;
        }(e)), E && 0 == +e && (E = !1), h = (E ? "(" === d ? d : u : "-" === d || "(" === d ? "" : d) + h, x = ("s" === b ? Bt[8 + Nt / 3] : "") + x + (E && "(" === d ? ")" : ""), w) for (i = -1, o = e.length; ++i < o;) {
          if (48 > (l = e.charCodeAt(i)) || l > 57) {
            x = (46 === l ? a + e.slice(i + 1) : e.slice(i)) + x, e = e.slice(0, i);
            break;
          }
        }
      }
      p && !m && (e = r(e, 1 / 0));
      var M = h.length + e.length + x.length,
          S = M < f ? new Array(f - M + 1).join(t) : "";

      switch (p && m && (e = r(S + e, S.length ? f - x.length : 1 / 0), S = ""), n) {
        case "<":
          e = h + e + x + S;
          break;

        case "=":
          e = h + S + e + x;
          break;

        case "^":
          e = S.slice(0, M = S.length >> 1) + h + e + x + S.slice(M);
          break;

        default:
          e = S + h + e + x;
      }

      return s(e);
    }

    return g = void 0 === g ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), x.toString = function () {
      return e + "";
    }, x;
  }

  return {
    format: d,
    formatPrefix: function formatPrefix(e, t) {
      var n = d(((e = Pt(e)).type = "f", e)),
          r = 3 * Math.max(-8, Math.min(8, Math.floor(Rt(t) / 3))),
          i = Math.pow(10, -r),
          o = Bt[8 + r / 3];
      return function (e) {
        return n(i * e) + o;
      };
    }
  };
}

function Yt(e, t, n, r) {
  var i,
      o = v(e, t, n);

  switch ((r = Pt(null == r ? ",f" : r)).type) {
    case "s":
      var a = Math.max(Math.abs(e), Math.abs(t));
      return null != r.precision || isNaN(i = function (e, t) {
        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(Rt(t) / 3))) - Rt(Math.abs(e)));
      }(o, a)) || (r.precision = i), Vt(r, a);

    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      null != r.precision || isNaN(i = function (e, t) {
        return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Rt(t) - Rt(e)) + 1;
      }(o, Math.max(Math.abs(e), Math.abs(t)))) || (r.precision = i - ("e" === r.type));
      break;

    case "f":
    case "%":
      null != r.precision || isNaN(i = function (e) {
        return Math.max(0, -Rt(Math.abs(e)));
      }(o)) || (r.precision = i - 2 * ("%" === r.type));
  }

  return Ht(r);
}

function Gt() {
  var e = Ot(Mt, Mt);
  return e.copy = function () {
    return At(e, Gt());
  }, oe.apply(e, arguments), function (e) {
    var t = e.domain;
    return e.ticks = function (e) {
      var n = t();
      return b(n[0], n[n.length - 1], null == e ? 10 : e);
    }, e.tickFormat = function (e, n) {
      var r = t();
      return Yt(r[0], r[r.length - 1], null == e ? 10 : e, n);
    }, e.nice = function (n) {
      null == n && (n = 10);
      var r,
          i = t(),
          o = 0,
          a = i.length - 1,
          s = i[o],
          l = i[a];
      return l < s && (r = s, s = l, l = r, r = o, o = a, a = r), (r = _(s, l, n)) > 0 ? (s = Math.floor(s / r) * r, l = Math.ceil(l / r) * r, r = _(s, l, n)) : r < 0 && (s = Math.ceil(s * r) / r, l = Math.floor(l * r) / r, r = _(s, l, n)), r > 0 ? (i[o] = Math.floor(s / r) * r, i[a] = Math.ceil(l / r) * r, t(i)) : r < 0 && (i[o] = Math.ceil(s * r) / r, i[a] = Math.floor(l * r) / r, t(i)), e;
    }, e;
  }(e);
}

Lt = Wt({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
}), Ht = Lt.format, Vt = Lt.formatPrefix;
var Zt = new Date(),
    $t = new Date();

function Jt(e, t, n, r) {
  function i(t) {
    return e(t = 0 === arguments.length ? new Date() : new Date(+t)), t;
  }

  return i.floor = function (t) {
    return e(t = new Date(+t)), t;
  }, i.ceil = function (n) {
    return e(n = new Date(n - 1)), t(n, 1), e(n), n;
  }, i.round = function (e) {
    var t = i(e),
        n = i.ceil(e);
    return e - t < n - e ? t : n;
  }, i.offset = function (e, n) {
    return t(e = new Date(+e), null == n ? 1 : Math.floor(n)), e;
  }, i.range = function (n, r, o) {
    var a,
        s = [];
    if (n = i.ceil(n), o = null == o ? 1 : Math.floor(o), !(n < r && o > 0)) return s;

    do {
      s.push(a = new Date(+n)), t(n, o), e(n);
    } while (a < n && n < r);

    return s;
  }, i.filter = function (n) {
    return Jt(function (t) {
      if (t >= t) for (; e(t), !n(t);) {
        t.setTime(t - 1);
      }
    }, function (e, r) {
      if (e >= e) if (r < 0) for (; ++r <= 0;) {
        for (; t(e, -1), !n(e);) {
          ;
        }
      } else for (; --r >= 0;) {
        for (; t(e, 1), !n(e);) {
          ;
        }
      }
    });
  }, n && (i.count = function (t, r) {
    return Zt.setTime(+t), $t.setTime(+r), e(Zt), e($t), Math.floor(n(Zt, $t));
  }, i.every = function (e) {
    return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? i.filter(r ? function (t) {
      return r(t) % e == 0;
    } : function (t) {
      return i.count(0, t) % e == 0;
    }) : i : null;
  }), i;
}

var Kt = Jt(function () {}, function (e, t) {
  e.setTime(+e + t);
}, function (e, t) {
  return t - e;
});

Kt.every = function (e) {
  return e = Math.floor(e), isFinite(e) && e > 0 ? e > 1 ? Jt(function (t) {
    t.setTime(Math.floor(t / e) * e);
  }, function (t, n) {
    t.setTime(+t + n * e);
  }, function (t, n) {
    return (n - t) / e;
  }) : Kt : null;
};

var Qt = 6e4,
    en = 6048e5,
    tn = Jt(function (e) {
  e.setTime(e - e.getMilliseconds());
}, function (e, t) {
  e.setTime(+e + 1e3 * t);
}, function (e, t) {
  return (t - e) / 1e3;
}, function (e) {
  return e.getUTCSeconds();
}),
    nn = Jt(function (e) {
  e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds());
}, function (e, t) {
  e.setTime(+e + t * Qt);
}, function (e, t) {
  return (t - e) / Qt;
}, function (e) {
  return e.getMinutes();
}),
    rn = Jt(function (e) {
  e.setTime(e - e.getMilliseconds() - 1e3 * e.getSeconds() - e.getMinutes() * Qt);
}, function (e, t) {
  e.setTime(+e + 36e5 * t);
}, function (e, t) {
  return (t - e) / 36e5;
}, function (e) {
  return e.getHours();
}),
    on = Jt(function (e) {
  e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setDate(e.getDate() + t);
}, function (e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Qt) / 864e5;
}, function (e) {
  return e.getDate() - 1;
});

function an(e) {
  return Jt(function (t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setDate(e.getDate() + 7 * t);
  }, function (e, t) {
    return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Qt) / en;
  });
}

var sn = an(0),
    ln = an(1),
    un = (an(2), an(3), an(4)),
    cn = (an(5), an(6), Jt(function (e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setMonth(e.getMonth() + t);
}, function (e, t) {
  return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
}, function (e) {
  return e.getMonth();
})),
    dn = Jt(function (e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function (e, t) {
  return t.getFullYear() - e.getFullYear();
}, function (e) {
  return e.getFullYear();
});

dn.every = function (e) {
  return isFinite(e = Math.floor(e)) && e > 0 ? Jt(function (t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function (t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  }) : null;
};

Jt(function (e) {
  e.setUTCSeconds(0, 0);
}, function (e, t) {
  e.setTime(+e + t * Qt);
}, function (e, t) {
  return (t - e) / Qt;
}, function (e) {
  return e.getUTCMinutes();
}), Jt(function (e) {
  e.setUTCMinutes(0, 0, 0);
}, function (e, t) {
  e.setTime(+e + 36e5 * t);
}, function (e, t) {
  return (t - e) / 36e5;
}, function (e) {
  return e.getUTCHours();
});
var hn = Jt(function (e) {
  e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function (e, t) {
  return (t - e) / 864e5;
}, function (e) {
  return e.getUTCDate() - 1;
});

function mn(e) {
  return Jt(function (t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setUTCDate(e.getUTCDate() + 7 * t);
  }, function (e, t) {
    return (t - e) / en;
  });
}

var fn = mn(0),
    pn = mn(1),
    gn = (mn(2), mn(3), mn(4)),
    vn = (mn(5), mn(6), Jt(function (e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function (e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
}, function (e) {
  return e.getUTCMonth();
}), Jt(function (e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function (e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function (e) {
  return e.getUTCFullYear();
}));

function bn(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }

  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}

function _n(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }

  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}

function yn(e, t, n) {
  return {
    y: e,
    m: t,
    d: n,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}

vn.every = function (e) {
  return isFinite(e = Math.floor(e)) && e > 0 ? Jt(function (t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function (t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  }) : null;
};

var kn,
    wn,
    xn,
    En,
    Mn = {
  "-": "",
  _: " ",
  0: "0"
},
    Sn = /^\s*\d+/,
    Tn = /^%/,
    Cn = /[\\^$*+?|[\]().{}]/g;

function Dn(e, t, n) {
  var r = e < 0 ? "-" : "",
      i = (r ? -e : e) + "",
      o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}

function An(e) {
  return e.replace(Cn, "\\$&");
}

function On(e) {
  return new RegExp("^(?:" + e.map(An).join("|") + ")", "i");
}

function Fn(e) {
  for (var t = {}, n = -1, r = e.length; ++n < r;) {
    t[e[n].toLowerCase()] = n;
  }

  return t;
}

function Rn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}

function Nn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}

function jn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}

function Pn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}

function zn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}

function Un(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}

function qn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}

function In(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}

function Ln(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 1));
  return r ? (e.q = 3 * r[0] - 3, n + r[0].length) : -1;
}

function Hn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}

function Vn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}

function Xn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}

function Bn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}

function Wn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}

function Yn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}

function Gn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}

function Zn(e, t, n) {
  var r = Sn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}

function $n(e, t, n) {
  var r = Tn.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}

function Jn(e, t, n) {
  var r = Sn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}

function Kn(e, t, n) {
  var r = Sn.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}

function Qn(e, t) {
  return Dn(e.getDate(), t, 2);
}

function er(e, t) {
  return Dn(e.getHours(), t, 2);
}

function tr(e, t) {
  return Dn(e.getHours() % 12 || 12, t, 2);
}

function nr(e, t) {
  return Dn(1 + on.count(dn(e), e), t, 3);
}

function rr(e, t) {
  return Dn(e.getMilliseconds(), t, 3);
}

function ir(e, t) {
  return rr(e, t) + "000";
}

function or(e, t) {
  return Dn(e.getMonth() + 1, t, 2);
}

function ar(e, t) {
  return Dn(e.getMinutes(), t, 2);
}

function sr(e, t) {
  return Dn(e.getSeconds(), t, 2);
}

function lr(e) {
  var t = e.getDay();
  return 0 === t ? 7 : t;
}

function ur(e, t) {
  return Dn(sn.count(dn(e) - 1, e), t, 2);
}

function cr(e, t) {
  var n = e.getDay();
  return e = n >= 4 || 0 === n ? un(e) : un.ceil(e), Dn(un.count(dn(e), e) + (4 === dn(e).getDay()), t, 2);
}

function dr(e) {
  return e.getDay();
}

function hr(e, t) {
  return Dn(ln.count(dn(e) - 1, e), t, 2);
}

function mr(e, t) {
  return Dn(e.getFullYear() % 100, t, 2);
}

function fr(e, t) {
  return Dn(e.getFullYear() % 1e4, t, 4);
}

function pr(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Dn(t / 60 | 0, "0", 2) + Dn(t % 60, "0", 2);
}

function gr(e, t) {
  return Dn(e.getUTCDate(), t, 2);
}

function vr(e, t) {
  return Dn(e.getUTCHours(), t, 2);
}

function br(e, t) {
  return Dn(e.getUTCHours() % 12 || 12, t, 2);
}

function _r(e, t) {
  return Dn(1 + hn.count(vn(e), e), t, 3);
}

function yr(e, t) {
  return Dn(e.getUTCMilliseconds(), t, 3);
}

function kr(e, t) {
  return yr(e, t) + "000";
}

function wr(e, t) {
  return Dn(e.getUTCMonth() + 1, t, 2);
}

function xr(e, t) {
  return Dn(e.getUTCMinutes(), t, 2);
}

function Er(e, t) {
  return Dn(e.getUTCSeconds(), t, 2);
}

function Mr(e) {
  var t = e.getUTCDay();
  return 0 === t ? 7 : t;
}

function Sr(e, t) {
  return Dn(fn.count(vn(e) - 1, e), t, 2);
}

function Tr(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || 0 === n ? gn(e) : gn.ceil(e), Dn(gn.count(vn(e), e) + (4 === vn(e).getUTCDay()), t, 2);
}

function Cr(e) {
  return e.getUTCDay();
}

function Dr(e, t) {
  return Dn(pn.count(vn(e) - 1, e), t, 2);
}

function Ar(e, t) {
  return Dn(e.getUTCFullYear() % 100, t, 2);
}

function Or(e, t) {
  return Dn(e.getUTCFullYear() % 1e4, t, 4);
}

function Fr() {
  return "+0000";
}

function Rr() {
  return "%";
}

function Nr(e) {
  return +e;
}

function jr(e) {
  return Math.floor(+e / 1e3);
}

!function (e) {
  kn = function (e) {
    var t = e.dateTime,
        n = e.date,
        r = e.time,
        i = e.periods,
        o = e.days,
        _a = e.shortDays,
        s = e.months,
        l = e.shortMonths,
        u = On(i),
        c = Fn(i),
        d = On(o),
        h = Fn(o),
        m = On(_a),
        f = Fn(_a),
        p = On(s),
        g = Fn(s),
        v = On(l),
        _b = Fn(l),
        _ = {
      a: function a(e) {
        return _a[e.getDay()];
      },
      A: function A(e) {
        return o[e.getDay()];
      },
      b: function b(e) {
        return l[e.getMonth()];
      },
      B: function B(e) {
        return s[e.getMonth()];
      },
      c: null,
      d: Qn,
      e: Qn,
      f: ir,
      H: er,
      I: tr,
      j: nr,
      L: rr,
      m: or,
      M: ar,
      p: function p(e) {
        return i[+(e.getHours() >= 12)];
      },
      q: function q(e) {
        return 1 + ~~(e.getMonth() / 3);
      },
      Q: Nr,
      s: jr,
      S: sr,
      u: lr,
      U: ur,
      V: cr,
      w: dr,
      W: hr,
      x: null,
      X: null,
      y: mr,
      Y: fr,
      Z: pr,
      "%": Rr
    },
        y = {
      a: function a(e) {
        return _a[e.getUTCDay()];
      },
      A: function A(e) {
        return o[e.getUTCDay()];
      },
      b: function b(e) {
        return l[e.getUTCMonth()];
      },
      B: function B(e) {
        return s[e.getUTCMonth()];
      },
      c: null,
      d: gr,
      e: gr,
      f: kr,
      H: vr,
      I: br,
      j: _r,
      L: yr,
      m: wr,
      M: xr,
      p: function p(e) {
        return i[+(e.getUTCHours() >= 12)];
      },
      q: function q(e) {
        return 1 + ~~(e.getUTCMonth() / 3);
      },
      Q: Nr,
      s: jr,
      S: Er,
      u: Mr,
      U: Sr,
      V: Tr,
      w: Cr,
      W: Dr,
      x: null,
      X: null,
      y: Ar,
      Y: Or,
      Z: Fr,
      "%": Rr
    },
        k = {
      a: function a(e, t, n) {
        var r = m.exec(t.slice(n));
        return r ? (e.w = f[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      A: function A(e, t, n) {
        var r = d.exec(t.slice(n));
        return r ? (e.w = h[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      b: function b(e, t, n) {
        var r = v.exec(t.slice(n));
        return r ? (e.m = _b[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      B: function B(e, t, n) {
        var r = p.exec(t.slice(n));
        return r ? (e.m = g[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      c: function c(e, n, r) {
        return E(e, t, n, r);
      },
      d: Vn,
      e: Vn,
      f: Zn,
      H: Bn,
      I: Bn,
      j: Xn,
      L: Gn,
      m: Hn,
      M: Wn,
      p: function p(e, t, n) {
        var r = u.exec(t.slice(n));
        return r ? (e.p = c[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      q: Ln,
      Q: Jn,
      s: Kn,
      S: Yn,
      u: Nn,
      U: jn,
      V: Pn,
      w: Rn,
      W: zn,
      x: function x(e, t, r) {
        return E(e, n, t, r);
      },
      X: function X(e, t, n) {
        return E(e, r, t, n);
      },
      y: qn,
      Y: Un,
      Z: In,
      "%": $n
    };

    function w(e, t) {
      return function (n) {
        var r,
            i,
            o,
            a = [],
            s = -1,
            l = 0,
            u = e.length;

        for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
          37 === e.charCodeAt(s) && (a.push(e.slice(l, s)), null != (i = Mn[r = e.charAt(++s)]) ? r = e.charAt(++s) : i = "e" === r ? " " : "0", (o = t[r]) && (r = o(n, i)), a.push(r), l = s + 1);
        }

        return a.push(e.slice(l, s)), a.join("");
      };
    }

    function x(e, t) {
      return function (n) {
        var r,
            i,
            o = yn(1900, void 0, 1);
        if (E(o, e, n += "", 0) != n.length) return null;
        if ("Q" in o) return new Date(o.Q);
        if ("s" in o) return new Date(1e3 * o.s + ("L" in o ? o.L : 0));

        if (!t || "Z" in o || (o.Z = 0), "p" in o && (o.H = o.H % 12 + 12 * o.p), void 0 === o.m && (o.m = "q" in o ? o.q : 0), "V" in o) {
          if (o.V < 1 || o.V > 53) return null;
          "w" in o || (o.w = 1), "Z" in o ? (i = (r = _n(yn(o.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? pn.ceil(r) : pn(r), r = hn.offset(r, 7 * (o.V - 1)), o.y = r.getUTCFullYear(), o.m = r.getUTCMonth(), o.d = r.getUTCDate() + (o.w + 6) % 7) : (i = (r = bn(yn(o.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? ln.ceil(r) : ln(r), r = on.offset(r, 7 * (o.V - 1)), o.y = r.getFullYear(), o.m = r.getMonth(), o.d = r.getDate() + (o.w + 6) % 7);
        } else ("W" in o || "U" in o) && ("w" in o || (o.w = "u" in o ? o.u % 7 : "W" in o ? 1 : 0), i = "Z" in o ? _n(yn(o.y, 0, 1)).getUTCDay() : bn(yn(o.y, 0, 1)).getDay(), o.m = 0, o.d = "W" in o ? (o.w + 6) % 7 + 7 * o.W - (i + 5) % 7 : o.w + 7 * o.U - (i + 6) % 7);

        return "Z" in o ? (o.H += o.Z / 100 | 0, o.M += o.Z % 100, _n(o)) : bn(o);
      };
    }

    function E(e, t, n, r) {
      for (var i, o, a = 0, s = t.length, l = n.length; a < s;) {
        if (r >= l) return -1;

        if (37 === (i = t.charCodeAt(a++))) {
          if (i = t.charAt(a++), !(o = k[i in Mn ? t.charAt(a++) : i]) || (r = o(e, n, r)) < 0) return -1;
        } else if (i != n.charCodeAt(r++)) return -1;
      }

      return r;
    }

    return _.x = w(n, _), _.X = w(r, _), _.c = w(t, _), y.x = w(n, y), y.X = w(r, y), y.c = w(t, y), {
      format: function format(e) {
        var t = w(e += "", _);
        return t.toString = function () {
          return e;
        }, t;
      },
      parse: function parse(e) {
        var t = x(e += "", !1);
        return t.toString = function () {
          return e;
        }, t;
      },
      utcFormat: function utcFormat(e) {
        var t = w(e += "", y);
        return t.toString = function () {
          return e;
        }, t;
      },
      utcParse: function utcParse(e) {
        var t = x(e += "", !0);
        return t.toString = function () {
          return e;
        }, t;
      }
    };
  }(e), wn = kn.format, kn.parse, xn = kn.utcFormat, En = kn.utcParse;
}({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
Date.prototype.toISOString || xn("%Y-%m-%dT%H:%M:%S.%LZ");
+new Date("2000-01-01T00:00:00.000Z") || En("%Y-%m-%dT%H:%M:%S.%LZ");
var Pr = 1e3,
    zr = 60 * Pr,
    Ur = 60 * zr,
    qr = 24 * Ur,
    Ir = 7 * qr,
    Lr = 30 * qr,
    Hr = 365 * qr;

function Vr(e) {
  return new Date(e);
}

function Xr(e) {
  return e instanceof Date ? +e : +new Date(+e);
}

function Br() {
  return oe.apply(function e(t, n, r, i, o, a, s, l, u) {
    var c = Ot(Mt, Mt),
        d = c.invert,
        h = c.domain,
        m = u(".%L"),
        f = u(":%S"),
        p = u("%I:%M"),
        g = u("%I %p"),
        b = u("%a %d"),
        _ = u("%b %d"),
        k = u("%B"),
        w = u("%Y"),
        x = [[s, 1, Pr], [s, 5, 5 * Pr], [s, 15, 15 * Pr], [s, 30, 30 * Pr], [a, 1, zr], [a, 5, 5 * zr], [a, 15, 15 * zr], [a, 30, 30 * zr], [o, 1, Ur], [o, 3, 3 * Ur], [o, 6, 6 * Ur], [o, 12, 12 * Ur], [i, 1, qr], [i, 2, 2 * qr], [r, 1, Ir], [n, 1, Lr], [n, 3, 3 * Lr], [t, 1, Hr]];

    function E(e) {
      return (s(e) < e ? m : a(e) < e ? f : o(e) < e ? p : i(e) < e ? g : n(e) < e ? r(e) < e ? b : _ : t(e) < e ? k : w)(e);
    }

    function M(e, n, r, i) {
      if (null == e && (e = 10), "number" == typeof e) {
        var o = Math.abs(r - n) / e,
            a = y(function (e) {
          return e[2];
        }).right(x, o);
        a === x.length ? (i = v(n / Hr, r / Hr, e), e = t) : a ? (i = (a = x[o / x[a - 1][2] < x[a][2] / o ? a - 1 : a])[1], e = a[0]) : (i = Math.max(v(n, r, e), 1), e = l);
      }

      return null == i ? e : e.every(i);
    }

    return c.invert = function (e) {
      return new Date(d(e));
    }, c.domain = function (e) {
      return arguments.length ? h(de.call(e, Xr)) : h().map(Vr);
    }, c.ticks = function (e, t) {
      var n,
          r = h(),
          i = r[0],
          o = r[r.length - 1],
          a = o < i;
      return a && (n = i, i = o, o = n), n = (n = M(e, i, o, t)) ? n.range(i, o + 1) : [], a ? n.reverse() : n;
    }, c.tickFormat = function (e, t) {
      return null == t ? E : u(t);
    }, c.nice = function (e, t) {
      var n = h();
      return (e = M(e, n[0], n[n.length - 1], t)) ? h(function (e, t) {
        var n,
            r = 0,
            i = (e = e.slice()).length - 1,
            o = e[r],
            a = e[i];
        return a < o && (n = r, r = i, i = n, n = o, o = a, a = n), e[r] = t.floor(o), e[i] = t.ceil(a), e;
      }(n, e)) : c;
    }, c.copy = function () {
      return At(c, e(t, n, r, i, o, a, s, l, u));
    }, c;
  }(dn, cn, sn, on, rn, nn, tn, Kt, wn).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}

function Wr(e, t) {
  if (null == e) return {};
  var n,
      r,
      i = {},
      o = Object.keys(e);

  for (r = 0; r < o.length; r++) {
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  }

  return i;
}

function Yr() {
  return (Yr = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var Gr = e(function (e, t) {
  function n(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(Wr),
      i = n(Yr),
      o = n(h),
      a = n(F);

  var s = void 0,
      l = void 0,
      u = [],
      c = function c(e) {
    return "undefined" != typeof window && window.requestAnimationFrame(e);
  },
      d = function d(e) {
    return "undefined" != typeof window && window.cancelAnimationFrame(e);
  },
      m = void 0,
      f = function f() {
    return Date.now();
  },
      p = void 0,
      g = void 0;

  var v = function v(e, t) {
    return l = {
      fn: e,
      transform: t
    };
  },
      b = function b(e) {
    return u = e;
  },
      _ = function _(e) {
    return s = e;
  },
      y = function y(e) {
    return m = e;
  },
      k = function k(e) {
    return p = e;
  },
      w = function w(e) {
    return g = e;
  };

  var x = Object.freeze({
    get bugfixes() {
      return s;
    },

    get applyAnimatedValues() {
      return l;
    },

    get colorNames() {
      return u;
    },

    get requestFrame() {
      return c;
    },

    get cancelFrame() {
      return d;
    },

    get interpolation() {
      return m;
    },

    get now() {
      return f;
    },

    get defaultElement() {
      return p;
    },

    get createAnimatedStyle() {
      return g;
    },

    injectApplyAnimatedValues: v,
    injectColorNames: b,
    injectBugfixes: _,
    injectInterpolation: y,
    injectFrame: function injectFrame(e, t) {
      var n = [e, t];
      return c = n[0], d = n[1], n;
    },
    injectNow: function injectNow(e) {
      return f = e;
    },
    injectDefaultElement: k,
    injectCreateAnimatedStyle: w
  });

  var E = /*#__PURE__*/function () {
    function E() {
      _classCallCheck(this, E);
    }

    _createClass(E, [{
      key: "attach",
      value: function attach() {}
    }, {
      key: "detach",
      value: function detach() {}
    }, {
      key: "getValue",
      value: function getValue() {}
    }, {
      key: "getAnimatedValue",
      value: function getAnimatedValue() {
        return this.getValue();
      }
    }, {
      key: "addChild",
      value: function addChild(e) {}
    }, {
      key: "removeChild",
      value: function removeChild(e) {}
    }, {
      key: "getChildren",
      value: function getChildren() {
        return [];
      }
    }]);

    return E;
  }();

  var M = function M(e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  };

  var S = /*#__PURE__*/function (_E) {
    _inherits(S, _E);

    function S() {
      var _this;

      _classCallCheck(this, S);

      var e;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(S).apply(this, arguments)), e = _assertThisInitialized(_assertThisInitialized(_this)), _this.children = [], _this.getChildren = function () {
        return _this.children;
      }, _this.getPayload = function (t) {
        return void 0 === t && (t = void 0), void 0 !== t && e.payload ? e.payload[t] : e.payload || e;
      };
      return _this;
    }

    _createClass(S, [{
      key: "addChild",
      value: function addChild(e) {
        0 === this.children.length && this.attach(), this.children.push(e);
      }
    }, {
      key: "removeChild",
      value: function removeChild(e) {
        var t = this.children.indexOf(e);
        this.children.splice(t, 1), 0 === this.children.length && this.detach();
      }
    }]);

    return S;
  }(E);

  var T = /*#__PURE__*/function (_S) {
    _inherits(T, _S);

    function T() {
      var _this2;

      _classCallCheck(this, T);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(T).apply(this, arguments)), _this2.payload = [], _this2.getAnimatedValue = function () {
        return _this2.getValue();
      }, _this2.attach = function () {
        return _this2.payload.forEach(function (e) {
          return e instanceof E && e.addChild(_assertThisInitialized(_assertThisInitialized(_this2)));
        });
      }, _this2.detach = function () {
        return _this2.payload.forEach(function (e) {
          return e instanceof E && e.removeChild(_assertThisInitialized(_assertThisInitialized(_this2)));
        });
      };
      return _this2;
    }

    return T;
  }(S);

  var C = /*#__PURE__*/function (_S2) {
    _inherits(C, _S2);

    function C() {
      var _this3;

      _classCallCheck(this, C);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(C).apply(this, arguments)), _this3.payload = {}, _this3.getAnimatedValue = function () {
        return _this3.getValue(!0);
      }, _this3.attach = function () {
        return M(_this3.payload).forEach(function (e) {
          return e instanceof E && e.addChild(_assertThisInitialized(_assertThisInitialized(_this3)));
        });
      }, _this3.detach = function () {
        return M(_this3.payload).forEach(function (e) {
          return e instanceof E && e.removeChild(_assertThisInitialized(_assertThisInitialized(_this3)));
        });
      };
      return _this3;
    }

    _createClass(C, [{
      key: "getValue",
      value: function getValue(e) {
        void 0 === e && (e = !1);
        var t = {};

        for (var _n2 in this.payload) {
          var _r2 = this.payload[_n2];
          (!e || _r2 instanceof E) && (t[_n2] = _r2 instanceof E ? _r2[e ? "getAnimatedValue" : "getValue"]() : _r2);
        }

        return t;
      }
    }]);

    return C;
  }(S);

  var D = /*#__PURE__*/function (_C) {
    _inherits(D, _C);

    function D(e) {
      var _this4;

      _classCallCheck(this, D);

      _this4 = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this)), !(e = e || {}).transform || e.transform instanceof E || (e = l.transform(e)), _this4.payload = e;
      return _this4;
    }

    return D;
  }(C);

  var A = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  };

  var O = /*#__PURE__*/function () {
    function O() {
      _classCallCheck(this, O);
    }

    _createClass(O, null, [{
      key: "create",
      value: function create(e, t, n) {
        if ("function" == typeof e) return e;
        if (m && e.output && "string" == typeof e.output[0]) return m(e);
        if (Array.isArray(e)) return O.create({
          range: e,
          output: t,
          extrapolate: n || "extend"
        });

        var r = e.output,
            i = e.range || [0, 1],
            o = e.easing || function (e) {
          return e;
        },
            a = "extend",
            s = e.map;

        void 0 !== e.extrapolateLeft ? a = e.extrapolateLeft : void 0 !== e.extrapolate && (a = e.extrapolate);
        var l = "extend";
        return void 0 !== e.extrapolateRight ? l = e.extrapolateRight : void 0 !== e.extrapolate && (l = e.extrapolate), function (e) {
          var t = function (e, t) {
            for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n) {
              ;
            }

            return n - 1;
          }(e, i);

          return function (e, t, n, r, i, o, a, s, l) {
            var u = l ? l(e) : e;

            if (u < t) {
              if ("identity" === a) return u;
              "clamp" === a && (u = t);
            }

            if (u > n) {
              if ("identity" === s) return u;
              "clamp" === s && (u = n);
            }

            if (r === i) return r;
            if (t === n) return e <= t ? r : i;
            t === -1 / 0 ? u = -u : n === 1 / 0 ? u -= t : u = (u - t) / (n - t);
            u = o(u), r === -1 / 0 ? u = -u : i === 1 / 0 ? u += r : u = u * (i - r) + r;
            return u;
          }(e, i[t], i[t + 1], r[t], r[t + 1], o, a, l, s);
        };
      }
    }]);

    return O;
  }();

  var R = "[-+]?\\d*\\.?\\d+",
      N = R + "%";

  function j() {
    return "\\(\\s*(" + Array.prototype.slice.call(arguments).join(")\\s*,\\s*(") + ")\\s*\\)";
  }

  var P = new RegExp("rgb" + j(R, R, R)),
      z = new RegExp("rgba" + j(R, R, R, R)),
      U = new RegExp("hsl" + j(R, N, N)),
      q = new RegExp("hsla" + j(R, N, N, R)),
      I = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      L = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      H = /^#([0-9a-fA-F]{6})$/,
      V = /^#([0-9a-fA-F]{8})$/;

  function X(e, t, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
  }

  function B(e, t, n) {
    var r = n < .5 ? n * (1 + t) : n + t - n * t,
        i = 2 * n - r,
        o = X(i, r, e + 1 / 3),
        a = X(i, r, e),
        s = X(i, r, e - 1 / 3);
    return Math.round(255 * o) << 24 | Math.round(255 * a) << 16 | Math.round(255 * s) << 8;
  }

  function W(e) {
    var t = parseInt(e, 10);
    return t < 0 ? 0 : t > 255 ? 255 : t;
  }

  function Y(e) {
    return (parseFloat(e) % 360 + 360) % 360 / 360;
  }

  function G(e) {
    var t = parseFloat(e);
    return t < 0 ? 0 : t > 1 ? 255 : Math.round(255 * t);
  }

  function Z(e) {
    var t = parseFloat(e);
    return t < 0 ? 0 : t > 100 ? 1 : t / 100;
  }

  function $(e) {
    var t = function (e) {
      var t;
      return "number" == typeof e ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = H.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : A.hasOwnProperty(e) ? A[e] : (t = P.exec(e)) ? (W(t[1]) << 24 | W(t[2]) << 16 | W(t[3]) << 8 | 255) >>> 0 : (t = z.exec(e)) ? (W(t[1]) << 24 | W(t[2]) << 16 | W(t[3]) << 8 | G(t[4])) >>> 0 : (t = I.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + "ff", 16) >>> 0 : (t = V.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = L.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + t[4] + t[4], 16) >>> 0 : (t = U.exec(e)) ? (255 | B(Y(t[1]), Z(t[2]), Z(t[3]))) >>> 0 : (t = q.exec(e)) ? (B(Y(t[1]), Z(t[2]), Z(t[3])) | G(t[4])) >>> 0 : null;
    }(e);

    return null === t ? e : "rgba(".concat((4278190080 & (t = t || 0)) >>> 24, ", ").concat((16711680 & t) >>> 16, ", ").concat((65280 & t) >>> 8, ", ").concat((255 & t) / 255, ")");
  }

  var J = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
      K = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
      Q = new RegExp("(".concat(Object.keys(A).join("|"), ")"), "g");

  var ee = /*#__PURE__*/function (_T) {
    _inherits(ee, _T);

    function ee(e, t, n) {
      var _this5;

      _classCallCheck(this, ee);

      _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ee).call(this)), _this5.getValue = function () {
        var _this6;

        return (_this6 = _this5).calc.apply(_this6, _toConsumableArray(_this5.payload.map(function (e) {
          return e.getValue();
        })));
      }, _this5.updateConfig = function (e, t) {
        return _this5.calc = O.create(e, t);
      }, _this5.interpolate = function (e, t) {
        return new ee(_assertThisInitialized(_assertThisInitialized(_this5)), e, t);
      }, _this5.payload = e instanceof T && !e.updateConfig ? e.payload : Array.isArray(e) ? e : [e], _this5.calc = O.create(t, n);
      return _this5;
    }

    return ee;
  }(T);

  var te = /*#__PURE__*/function (_S3) {
    _inherits(te, _S3);

    function te(e) {
      var _this7;

      _classCallCheck(this, te);

      var t;
      _this7 = _possibleConstructorReturn(this, _getPrototypeOf(te).call(this)), t = _assertThisInitialized(_assertThisInitialized(_this7)), _this7.setValue = function (e, n) {
        void 0 === n && (n = !0), t.value = e, n && t.flush();
      }, _this7.getValue = function () {
        return _this7.value;
      }, _this7.updateStyles = function () {
        return function e(t, n) {
          "function" == typeof t.update ? n.add(t) : t.getChildren().forEach(function (t) {
            return e(t, n);
          });
        }(_assertThisInitialized(_assertThisInitialized(_this7)), _this7.animatedStyles);
      }, _this7.updateValue = function (e) {
        return _this7.flush(_this7.value = e);
      }, _this7.interpolate = function (e, t) {
        return new ee(_assertThisInitialized(_assertThisInitialized(_this7)), e, t);
      }, _this7.value = e, _this7.animatedStyles = new Set(), _this7.done = !1, _this7.startPosition = e, _this7.lastPosition = e, _this7.lastVelocity = void 0, _this7.lastTime = void 0, _this7.controller = void 0;
      return _this7;
    }

    _createClass(te, [{
      key: "flush",
      value: function flush() {
        0 === this.animatedStyles.size && this.updateStyles(), this.animatedStyles.forEach(function (e) {
          return e.update();
        });
      }
    }, {
      key: "prepare",
      value: function prepare(e) {
        void 0 === this.controller && (this.controller = e), this.controller === e && (this.startPosition = this.value, this.lastPosition = this.value, this.lastVelocity = e.isActive ? this.lastVelocity : void 0, this.lastTime = e.isActive ? this.lastTime : void 0, this.done = !1, this.animatedStyles.clear());
      }
    }]);

    return te;
  }(S);

  var ne = /*#__PURE__*/function (_T2) {
    _inherits(ne, _T2);

    function ne(e) {
      var _this8;

      _classCallCheck(this, ne);

      var t;
      _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ne).call(this)), t = _assertThisInitialized(_assertThisInitialized(_this8)), _this8.setValue = function (e, n) {
        void 0 === n && (n = !0), Array.isArray(e) ? e.length === t.payload.length && e.forEach(function (e, r) {
          return t.payload[r].setValue(e, n);
        }) : t.payload.forEach(function (r, i) {
          return t.payload[i].setValue(e, n);
        });
      }, _this8.getValue = function () {
        return _this8.payload.map(function (e) {
          return e.getValue();
        });
      }, _this8.interpolate = function (e, t) {
        return new ee(_assertThisInitialized(_assertThisInitialized(_this8)), e, t);
      }, _this8.payload = e.map(function (e) {
        return new te(e);
      });
      return _this8;
    }

    return ne;
  }(T);

  function re(e, t) {
    return null == e ? t : e;
  }

  function ie(e) {
    return void 0 !== e ? Array.isArray(e) ? e : [e] : [];
  }

  function oe(e, t) {
    if (typeof e != typeof t) return !1;
    if ("string" == typeof e || "number" == typeof e) return e === t;
    var n;

    for (n in e) {
      if (!(n in t)) return !1;
    }

    for (n in t) {
      if (e[n] !== t[n]) return !1;
    }

    return void 0 !== n || e === t;
  }

  function ae(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
      n[r - 1] = arguments[r];
    }

    return "function" == typeof e ? e.apply(void 0, n) : e;
  }

  function se(e) {
    return Object.keys(e).map(function (t) {
      return e[t];
    });
  }

  function le(e) {
    var t = function (e) {
      return e.to, e.from, e.config, e.native, e.onStart, e.onRest, e.onFrame, e.children, e.reset, e.reverse, e.force, e.immediate, e.impl, e.inject, e.delay, e.attach, e.destroyed, e.interpolateTo, e.autoStart, e.ref, r(e, ["to", "from", "config", "native", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "impl", "inject", "delay", "attach", "destroyed", "interpolateTo", "autoStart", "ref"]);
    }(e),
        n = Object.keys(e).reduce(function (n, r) {
      return void 0 !== t[r] ? n : i({}, n, _defineProperty({}, r, e[r]));
    }, {});

    return i({
      to: t
    }, n);
  }

  function ue(e, t) {
    var n = t[0],
        r = t[1];
    return i({}, e, _defineProperty({}, n, new (Array.isArray(r) ? ne : te)(r)));
  }

  function ce(e) {
    var t = e.from,
        n = e.to,
        r = e.native,
        o = Object.entries(i({}, t, n));
    return r ? o.reduce(ue, {}) : i({}, t, n);
  }

  function de(e, t) {
    return t && ("function" == typeof t ? t(e) : "object" == typeof t && (t.current = e)), e;
  }

  var he = function he(e) {
    return "auto" === e;
  },
      me = function me(e, t) {
    return function (n, r) {
      var o = r[0],
          a = r[1];
      return i({}, n, _defineProperty({}, o, "auto" === a ? ~o.indexOf("height") ? t : e : a));
    };
  };

  var fe = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  };
  var pe = ["Webkit", "Ms", "Moz", "O"];

  function ge(e, t, n) {
    return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || fe.hasOwnProperty(e) && fe[e] ? ("" + t).trim() : t + "px";
  }

  fe = Object.keys(fe).reduce(function (e, t) {
    return pe.forEach(function (n) {
      return e[function (e, t) {
        return e + t.charAt(0).toUpperCase() + t.substring(1);
      }(n, t)] = e[t];
    }), e;
  }, fe);
  var ve = {};
  w(function (e) {
    return new D(e);
  }), k("div"), y(function (e) {
    var t = e.output.map(function (e) {
      return e.replace(K, $);
    }).map(function (e) {
      return e.replace(Q, $);
    }),
        n = t[0].match(J).map(function () {
      return [];
    });
    t.forEach(function (e) {
      e.match(J).forEach(function (e, t) {
        return n[t].push(+e);
      });
    });
    var r = t[0].match(J).map(function (t, r) {
      return O.create(i({}, e, {
        output: n[r]
      }));
    });
    return function (e) {
      var n = 0;
      return t[0].replace(J, function () {
        return r[n++](e);
      }).replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (e, t, n, r, i) {
        return "rgba(".concat(Math.round(t), ", ").concat(Math.round(n), ", ").concat(Math.round(r), ", ").concat(i, ")");
      });
    };
  }), b(A), _(function (e, t) {
    var n = e.from,
        r = e.to,
        s = e.children;
    if (!se(r).some(he) && !se(n).some(he)) return;
    var l = s(ce(e));
    if (!l) return;
    Array.isArray(l) && (l = {
      type: "div",
      props: {
        children: l
      }
    });
    var u = l.props.style;
    return o.createElement(l.type, i({
      key: l.key ? l.key : void 0
    }, l.props, {
      style: i({}, u, {
        position: "absolute",
        visibility: "hidden"
      }),
      ref: function ref(o) {
        if (o) {
          var _s,
              _l,
              _u = a.findDOMNode(o),
              _c = getComputedStyle(_u);

          if ("border-box" === _c.boxSizing) _s = _u.offsetWidth, _l = _u.offsetHeight;else {
            var _e3 = parseFloat(_c.paddingLeft || 0) + parseFloat(_c.paddingRight || 0),
                _t2 = parseFloat(_c.paddingTop || 0) + parseFloat(_c.paddingBottom || 0),
                _n3 = parseFloat(_c.borderLeftWidth || 0) + parseFloat(_c.borderRightWidth || 0),
                _r3 = parseFloat(_c.borderTopWidth || 0) + parseFloat(_c.borderBottomWidth || 0);

            _s = _u.offsetWidth - _e3 - _n3, _l = _u.offsetHeight - _t2 - _r3;
          }

          var _d = me(_s, _l);

          t(i({}, e, {
            from: Object.entries(n).reduce(_d, n),
            to: Object.entries(r).reduce(_d, r)
          }));
        }
      }
    }));
  }), v(function (e, t) {
    if (!e.nodeType || void 0 === e.setAttribute) return !1;
    {
      var _o2 = t.style,
          _a2 = t.children,
          _s2 = t.scrollTop,
          _l2 = t.scrollLeft,
          _u2 = r(t, ["style", "children", "scrollTop", "scrollLeft"]);

      void 0 !== _s2 && (e.scrollTop = _s2), void 0 !== _l2 && (e.scrollLeft = _l2), void 0 !== _a2 && (e.textContent = _a2);

      for (var _t3 in _o2) {
        if (_o2.hasOwnProperty(_t3)) {
          var n = 0 === _t3.indexOf("--"),
              i = ge(_t3, _o2[_t3], n);

          "float" === _t3 && (_t3 = "cssFloat"), n ? e.style.setProperty(_t3, i) : e.style[_t3] = i;
        }
      }

      for (var _t4 in _u2) {
        var _n4 = ve[_t4] || (ve[_t4] = _t4.replace(/([A-Z])/g, function (e) {
          return "-" + e.toLowerCase();
        }));

        void 0 !== e.getAttribute(_n4) && e.setAttribute(_n4, _u2[_t4]);
      }
    }
  }, function (e) {
    return e;
  });
  var be = !1;

  var _e = new Set(),
      ye = function ye() {
    var e = f();

    var _iterator = _createForOfIteratorHelper(_e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t5 = _step.value;

        var _n5 = !0,
            _r4 = !0;

        for (var _i5 = 0; _i5 < _t5.configs.length; _i5++) {
          var _o3 = void 0,
              _a3 = void 0,
              _s3 = _t5.configs[_i5];

          for (var _i6 = 0; _i6 < _s3.animatedValues.length; _i6++) {
            var _l3 = _s3.animatedValues[_i6];
            if (_l3.done) continue;

            var _u3 = _s3.fromValues[_i6],
                _c2 = _s3.toValues[_i6],
                _d2 = _l3.lastPosition,
                _h = _c2 instanceof E,
                _m = Array.isArray(_s3.initialVelocity) ? _s3.initialVelocity[_i6] : _s3.initialVelocity;

            if (_h && (_c2 = _c2.getValue()), _s3.immediate || !_h && !_s3.decay && _u3 === _c2) _l3.updateValue(_c2), _l3.done = !0;else if (_s3.delay && e - _t5.startTime < _s3.delay) _n5 = !1;else if (_r4 = !1, "string" != typeof _u3 && "string" != typeof _c2) {
              if (void 0 !== _s3.duration) _d2 = _u3 + _s3.easing((e - _t5.startTime - _s3.delay) / _s3.duration) * (_c2 - _u3), _o3 = e >= _t5.startTime + _s3.delay + _s3.duration;else if (_s3.decay) _d2 = _u3 + _m / (1 - .998) * (1 - Math.exp(-(1 - .998) * (e - _t5.startTime))), (_o3 = Math.abs(_l3.lastPosition - _d2) < .1) && (_c2 = _d2);else {
                _a3 = void 0 !== _l3.lastTime ? _l3.lastTime : e, _m = void 0 !== _l3.lastVelocity ? _l3.lastVelocity : _s3.initialVelocity, e > _a3 + 64 && (_a3 = e);

                var _t6 = Math.floor(e - _a3);

                for (var _e4 = 0; _e4 < _t6; ++_e4) {
                  _d2 += 1 * (_m += 1 * ((-_s3.tension * (_d2 - _c2) + -_s3.friction * _m) / _s3.mass) / 1e3) / 1e3;
                }

                var _n6 = !(!_s3.clamp || 0 === _s3.tension) && (_u3 < _c2 ? _d2 > _c2 : _d2 < _c2),
                    _r5 = Math.abs(_m) <= _s3.precision,
                    _i7 = 0 === _s3.tension || Math.abs(_c2 - _d2) <= _s3.precision;

                _o3 = _n6 || _r5 && _i7, _l3.lastVelocity = _m, _l3.lastTime = e;
              }
              _h && !_s3.toValues[_i6].done && (_o3 = !1), _o3 ? (_l3.value !== _c2 && (_d2 = _c2), _l3.done = !0) : _n5 = !1, _l3.updateValue(_d2), _l3.lastPosition = _d2;
            } else _l3.updateValue(_c2), _l3.done = !0;
          }

          !_t5.props.onFrame && _t5.props.native || (_t5.animatedProps[_s3.name] = _s3.interpolation.getValue());
        }

        !_t5.props.onFrame && _t5.props.native || (!_t5.props.native && _t5.onUpdate && _t5.onUpdate(), _t5.props.onFrame && _t5.props.onFrame(_t5.animatedProps)), _n5 && (_e.delete(_t5), _t5.debouncedOnEnd({
          finished: !0,
          noChange: _r4
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _e.size ? c(ye) : be = !1;
  },
      ke = function ke(e) {
    _e.has(e) || (_e.add(e), be || c(ye), be = !0);
  },
      we = function we(e) {
    _e.has(e) && _e.delete(e);
  };

  var xe = /*#__PURE__*/function () {
    function xe(e, t) {
      var _this9 = this;

      _classCallCheck(this, xe);

      void 0 === t && (t = {
        native: !0,
        interpolateTo: !0,
        autoStart: !0
      }), this.getValues = function () {
        return _this9.props.native ? _this9.interpolations : _this9.animatedProps;
      }, this.dependents = new Set(), this.isActive = !1, this.hasChanged = !1, this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.animatedProps = {}, this.configs = [], this.frame = void 0, this.startTime = void 0, this.lastTime = void 0, this.update(i({}, e, t));
    }

    _createClass(xe, [{
      key: "update",
      value: function update(e) {
        var _this10 = this;

        this.props = i({}, this.props, e);
        var t = this.props.interpolateTo ? le(this.props) : this.props,
            n = t.from,
            r = void 0 === n ? {} : n,
            o = t.to,
            a = void 0 === o ? {} : o,
            s = t.config,
            l = void 0 === s ? {} : s,
            c = t.delay,
            d = void 0 === c ? 0 : c,
            h = t.reverse,
            m = t.attach,
            f = t.reset,
            p = t.immediate,
            g = t.autoStart,
            v = t.ref;

        if (h) {
          var b = [a, r];
          r = b[0], a = b[1];
        }

        this.hasChanged = !1;

        var _ = m && m(this),
            y = f ? {} : this.merged;

        if (this.merged = i({}, r, y, a), this.animations = Object.entries(this.merged).reduce(function (e, t, n) {
          var o = t[0],
              a = t[1],
              s = !f && e[o] || {};
          var c = "number" == typeof a,
              h = "string" == typeof a && !a.startsWith("#") && !/\d/.test(a) && !u[a],
              m = !c && !h && Array.isArray(a);
          var g = void 0 !== r[o] ? r[o] : a,
              v = c || m ? a : h ? a : 1,
              b = ae(l, o);
          if (_ && (v = _.animations[o].parent), void 0 === b.decay && oe(s.changes, a)) return e;
          {
            var _t7, _n7;

            if (_this10.hasChanged = !0, c || h) _t7 = _n7 = s.parent || new te(g);else if (m) _t7 = _n7 = s.parent || new ne(g);else {
              var _e5 = s.interpolation && s.interpolation.calc(s.parent.value);

              s.parent ? (_t7 = s.parent).setValue(0, !1) : _t7 = new te(0);
              var _r7 = {
                output: [void 0 !== _e5 ? _e5 : g, a]
              };
              s.interpolation ? (_n7 = s.interpolation, s.interpolation.updateConfig(_r7)) : _n7 = _t7.interpolate(_r7);
            }
            ae(p, o) && _t7.setValue(a, !1);

            var _r6 = ie(_t7.getPayload());

            return _r6.forEach(function (e) {
              return e.prepare(_this10);
            }), i({}, e, _defineProperty({}, o, i({}, s, {
              name: o,
              parent: _t7,
              interpolation: _n7,
              animatedValues: _r6,
              changes: a,
              fromValues: ie(_t7.getValue()),
              toValues: ie(_ ? v.getPayload() : v),
              immediate: ae(p, o),
              delay: re(b.delay, d || 0),
              initialVelocity: re(b.velocity, 0),
              clamp: re(b.clamp, !1),
              precision: re(b.precision, .01),
              tension: re(b.tension, 170),
              friction: re(b.friction, 26),
              mass: re(b.mass, 1),
              duration: b.duration,
              easing: re(b.easing, function (e) {
                return e;
              }),
              decay: b.decay
            })));
          }
        }, this.animations), this.hasChanged) {
          this.configs = se(this.animations), this.animatedProps = {}, this.interpolations = {};

          for (var _e6 in this.animations) {
            this.interpolations[_e6] = this.animations[_e6].interpolation, this.animatedProps[_e6] = this.animations[_e6].interpolation.getValue();
          }
        }

        for (var k = arguments.length, w = new Array(k > 1 ? k - 1 : 0), x = 1; x < k; x++) {
          w[x - 1] = arguments[x];
        }

        v || !g && !w.length || this.start.apply(this, w);
        var E = w[0],
            M = w[1];
        return this.onEnd = "function" == typeof E && E, this.onUpdate = M, this.getValues();
      }
    }, {
      key: "start",
      value: function start(e, t) {
        var _this11 = this;

        return this.startTime = f(), this.isActive && this.stop(), this.isActive = !0, this.onEnd = "function" == typeof e && e, this.onUpdate = t, this.props.onStart && this.props.onStart(), ke(this), new Promise(function (e) {
          return _this11.resolve = e;
        });
      }
    }, {
      key: "stop",
      value: function stop(e) {
        void 0 === e && (e = !1), e && se(this.animations).forEach(function (e) {
          return e.changes = void 0;
        }), this.debouncedOnEnd({
          finished: e
        });
      }
    }, {
      key: "destroy",
      value: function destroy() {
        we(this), this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.animatedProps = {}, this.configs = [];
      }
    }, {
      key: "debouncedOnEnd",
      value: function debouncedOnEnd(e) {
        we(this), this.isActive = !1;
        var t = this.onEnd;
        this.onEnd = null, t && t(e), this.resolve && this.resolve(), this.resolve = null;
      }
    }]);

    return xe;
  }();

  var Ee = /*#__PURE__*/function (_C2) {
    _inherits(Ee, _C2);

    function Ee(e, t) {
      var _this12;

      _classCallCheck(this, Ee);

      _this12 = _possibleConstructorReturn(this, _getPrototypeOf(Ee).call(this)), e.style && (e = i({}, e, {
        style: g(e.style)
      })), _this12.payload = e, _this12.update = t, _this12.attach();
      return _this12;
    }

    return Ee;
  }(C);

  function Me(e) {
    var t = /*#__PURE__*/function (_o$Component) {
      _inherits(t, _o$Component);

      function t(e) {
        var _this13;

        _classCallCheck(this, t);

        _this13 = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this)), _this13.callback = function () {
          if (_this13.node) {
            !1 === l.fn(_this13.node, _this13.propsAnimated.getAnimatedValue(), _assertThisInitialized(_assertThisInitialized(_this13))) && _this13.forceUpdate();
          }
        }, _this13.attachProps(e);
        return _this13;
      }

      _createClass(t, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.propsAnimated && this.propsAnimated.detach();
        }
      }, {
        key: "setNativeProps",
        value: function setNativeProps(e) {
          !1 === l.fn(this.node, e, this) && this.forceUpdate();
        }
      }, {
        key: "attachProps",
        value: function attachProps(e) {
          e.forwardRef;
          var t = r(e, ["forwardRef"]);
          var n = this.propsAnimated;
          this.propsAnimated = new Ee(t, this.callback), n && n.detach();
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(e) {
          var t = e.style,
              n = r(e, ["style"]),
              i = this.props,
              o = i.style;
          return (!oe(r(i, ["style"]), n) || !oe(o, t)) && (this.attachProps(e), !0);
        }
      }, {
        key: "render",
        value: function render() {
          var _this14 = this;

          var t = this.propsAnimated.getValue(),
              n = (t.scrollTop, t.scrollLeft, r(t, ["scrollTop", "scrollLeft"]));
          return o.createElement(e, i({}, n, {
            ref: function ref(e) {
              return _this14.node = de(e, _this14.props.forwardRef);
            }
          }));
        }
      }]);

      return t;
    }(o.Component);

    return o.forwardRef(function (e, n) {
      return o.createElement(t, i({}, e, {
        forwardRef: n
      }));
    });
  }

  var Se = {
    default: {
      tension: 170,
      friction: 26
    },
    gentle: {
      tension: 120,
      friction: 14
    },
    wobbly: {
      tension: 180,
      friction: 12
    },
    stiff: {
      tension: 210,
      friction: 20
    },
    slow: {
      tension: 280,
      friction: 60
    },
    molasses: {
      tension: 280,
      friction: 120
    }
  };

  var Te = /*#__PURE__*/function (_o$Component2) {
    _inherits(Te, _o$Component2);

    function Te() {
      var _this15;

      _classCallCheck(this, Te);

      _this15 = _possibleConstructorReturn(this, _getPrototypeOf(Te).apply(this, arguments)), _this15.state = {
        lastProps: {
          from: {},
          to: {}
        },
        propsChanged: !1,
        internal: !1
      }, _this15.controller = new xe(null, null), _this15.didUpdate = !1, _this15.didInject = !1, _this15.finished = !0, _this15.start = function () {
        _this15.finished = !1;
        var e = _this15.mounted;

        _this15.controller.start(function (t) {
          return _this15.finish(i({}, t, {
            wasMounted: e
          }));
        }, _this15.update);
      }, _this15.stop = function () {
        return _this15.controller.stop(!0);
      }, _this15.update = function () {
        return _this15.mounted && _this15.setState({
          internal: !0
        });
      }, _this15.finish = function (e) {
        var t = e.finished,
            n = e.noChange,
            r = e.wasMounted;
        _this15.finished = !0, _this15.mounted && t && (!_this15.props.onRest || !r && n || _this15.props.onRest(_this15.controller.merged), _this15.mounted && _this15.didInject && (_this15.afterInject = ce(_this15.props), _this15.setState({
          internal: !0
        })), _this15.mounted && (_this15.didInject || _this15.props.after) && _this15.setState({
          internal: !0
        }), _this15.didInject = !1);
      };
      return _this15;
    }

    _createClass(Te, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate(), this.mounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = !1, this.stop();
      }
    }, {
      key: "render",
      value: function render() {
        var _this16 = this;

        var e = this.props.children,
            t = this.state.propsChanged;

        if (this.props.inject && t && !this.injectProps) {
          var _e7 = this.props.inject(this.props, function (e) {
            _this16.injectProps = e, _this16.setState({
              internal: !0
            });
          });

          if (_e7) return _e7;
        }

        (this.injectProps || t) && (this.didInject = !1, this.injectProps ? (this.controller.update(this.injectProps), this.didInject = !0) : t && this.controller.update(this.props), this.didUpdate = !0, this.afterInject = void 0, this.injectProps = void 0);
        var n = i({}, this.controller.getValues(), this.afterInject);
        return this.finished && (n = i({}, n, this.props.after)), Object.keys(n).length ? e(n) : null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.didUpdate && this.start(), this.didUpdate = !1;
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(e, t) {
        var n = t.internal,
            r = t.lastProps;
        var i = e.from,
            o = e.to,
            a = e.reset,
            s = e.force;
        return {
          propsChanged: !oe(o, r.to) || !oe(i, r.from) || a && !n || s && !n,
          lastProps: e,
          internal: !1
        };
      }
    }]);

    return Te;
  }(o.Component);

  Te.defaultProps = {
    from: {},
    to: {},
    config: Se.default,
    native: !1,
    immediate: !1,
    reset: !1,
    force: !1,
    inject: s
  };

  var Ce = /*#__PURE__*/function (_o$PureComponent) {
    _inherits(Ce, _o$PureComponent);

    function Ce() {
      var _this17;

      _classCallCheck(this, Ce);

      _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Ce).apply(this, arguments)), _this17.first = !0, _this17.instances = new Set(), _this17.hook = function (e, t, n, r) {
        return _this17.instances.add(e), (r ? t === n - 1 : 0 === t) ? void 0 : Array.from(_this17.instances)[r ? t + 1 : t - 1];
      };
      return _this17;
    }

    _createClass(Ce, [{
      key: "render",
      value: function render() {
        var _this18 = this;

        var e = this.props,
            t = e.items,
            n = e.children,
            a = e.from,
            s = void 0 === a ? {} : a,
            l = e.initial,
            u = e.reverse,
            c = e.keys,
            d = e.delay,
            h = e.onRest,
            m = r(e, ["items", "children", "from", "initial", "reverse", "keys", "delay", "onRest"]),
            f = ie(t);
        return ie(f).map(function (e, t) {
          return o.createElement(Te, i({
            onRest: 0 === t ? h : null,
            key: "function" == typeof c ? c(e) : ie(c)[t],
            from: _this18.first && void 0 !== l ? l || {} : s
          }, m, {
            delay: 0 === t && d || void 0,
            attach: function attach(e) {
              return _this18.hook(e, t, f.length, u);
            },
            children: function children(r) {
              var i = n(e, t);
              return i ? i(r) : null;
            }
          }));
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(e) {
        this.first = !1, e.items !== this.props.items && this.instances.clear();
      }
    }]);

    return Ce;
  }(o.PureComponent);

  Ce.defaultProps = {
    keys: function keys(e) {
      return e;
    }
  };

  var De = /*#__PURE__*/function (_o$PureComponent2) {
    _inherits(De, _o$PureComponent2);

    function De() {
      var _this19;

      _classCallCheck(this, De);

      var e;
      _this19 = _possibleConstructorReturn(this, _getPrototypeOf(De).apply(this, arguments)), e = _assertThisInitialized(_assertThisInitialized(_this19)), _this19.guid = 0, _this19.state = {
        props: {},
        resolve: function resolve() {
          return null;
        },
        last: !0,
        index: 0
      }, _this19.next = function (t, n, r) {
        return void 0 === n && (n = !0), void 0 === r && (r = 0), e.running = !0, new Promise(function (i) {
          e.mounted && e.setState(function (e) {
            return {
              props: t,
              resolve: i,
              last: n,
              index: r
            };
          }, function () {
            return e.running = !1;
          });
        });
      };
      return _this19;
    }

    _createClass(De, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = !0, this.componentDidUpdate({});
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = !1;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(e) {
        var _this20 = this;

        var t = this;
        var n = this.props,
            r = n.states,
            i = n.filter,
            o = n.state;

        if ((e.state !== this.props.state || this.props.reset && !this.running || !oe(r[o], e.states[e.state])) && r && o && r[o]) {
          (function () {
            var e = ++_this20.guid,
                n = r[o];
            if (n) if (Array.isArray(n)) {
              var _t8 = Promise.resolve();

              var _loop = function _loop(_r8) {
                var o = _r8,
                    a = n[o],
                    s = o === n.length - 1;
                _t8 = _t8.then(function () {
                  return e === _this20.guid && _this20.next(i(a), s, o);
                });
              };

              for (var _r8 = 0; _r8 < n.length; _r8++) {
                _loop(_r8);
              }
            } else if ("function" == typeof n) {
              var _r9 = 0;
              n(function (n, o) {
                return void 0 === o && (o = !1), e === t.guid && t.next(i(n), o, _r9++);
              }, function () {
                return c(function () {
                  return _this20.instance && _this20.instance.stop();
                });
              }, _this20.props);
            } else _this20.next(i(r[o]));
          })();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this21 = this;

        var e = this.state,
            t = e.props,
            n = e.resolve,
            a = e.last,
            s = e.index;
        if (!t || 0 === Object.keys(t).length) return null;
        var l = this.props,
            u = (l.state, l.filter, l.states, l.config),
            c = l.primitive,
            d = l.onRest,
            h = l.forwardRef,
            m = r(l, ["state", "filter", "states", "config", "primitive", "onRest", "forwardRef"]);
        return Array.isArray(u) && (u = u[s]), o.createElement(c, i({
          ref: function ref(e) {
            return _this21.instance = de(e, h);
          },
          config: u
        }, m, t, {
          onRest: function onRest(e) {
            n(e), d && a && d(e);
          }
        }));
      }
    }]);

    return De;
  }(o.PureComponent);

  De.defaultProps = {
    state: "__default"
  };
  var Ae = o.forwardRef(function (e, t) {
    return o.createElement(De, i({}, e, {
      forwardRef: t
    }));
  });
  Ae.create = function (e) {
    return function (t, n) {
      return void 0 === n && (n = function n(e) {
        return e;
      }), ("function" == typeof t || Array.isArray(t)) && (t = {
        __default: t
      }), function (r) {
        return o.createElement(De, i({
          primitive: e,
          states: t,
          filter: n
        }, r));
      };
    };
  }, Ae.Spring = function (e) {
    return Ae.create(Te)(e, le);
  }, Ae.Trail = function (e) {
    return Ae.create(Ce)(e, le);
  };

  var Oe = 0,
      Fe = function Fe(e) {
    var t = e.items,
        n = e.keys,
        o = r(e, ["items", "keys"]);
    return t = ie(void 0 !== t ? t : null), n = "function" == typeof n ? t.map(n) : ie(n), i({
      items: t,
      keys: n.map(function (e) {
        return String(e);
      })
    }, o);
  };

  var Re = /*#__PURE__*/function (_o$PureComponent3) {
    _inherits(Re, _o$PureComponent3);

    _createClass(Re, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = !1;
      }
    }]);

    function Re(e) {
      var _this22;

      _classCallCheck(this, Re);

      _this22 = _possibleConstructorReturn(this, _getPrototypeOf(Re).call(this, e)), _this22.destroyItem = function (e, t, n) {
        return function (r) {
          var i = _this22.props,
              o = i.onRest,
              a = i.onDestroyed;
          _this22.mounted && (a && a(e), _this22.setState(function (e) {
            return {
              deleted: e.deleted.filter(function (e) {
                return e.key !== t;
              })
            };
          }), o && o(e, n, r));
        };
      }, _this22.state = {
        first: !0,
        transitions: [],
        current: {},
        deleted: [],
        prevProps: e
      };
      return _this22;
    }

    _createClass(Re, [{
      key: "render",
      value: function render() {
        var _this23 = this;

        var e = this.props,
            t = (e.initial, e.from, e.enter, e.leave, e.update, e.onDestroyed, e.keys, e.items, e.onFrame),
            n = e.onRest,
            a = e.onStart,
            s = (e.trail, e.config, e.children),
            l = (e.unique, e.reset),
            u = r(e, ["initial", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "trail", "config", "children", "unique", "reset"]);
        return this.state.transitions.map(function (e, r) {
          var c = e.state,
              d = e.key,
              h = e.item,
              m = e.from,
              f = e.to,
              p = e.trail,
              g = e.config,
              v = e.destroyed;
          return o.createElement(Ae, i({
            reset: l && "enter" === c,
            primitive: Te,
            state: c,
            filter: le,
            states: _defineProperty({}, c, f),
            key: d,
            onRest: v ? _this23.destroyItem(h, d, c) : n && function (e) {
              return n(h, c, e);
            },
            onStart: a && function () {
              return a(h, c);
            },
            onFrame: t && function (e) {
              return t(h, c, e);
            },
            delay: p,
            config: g
          }, u, {
            from: m,
            children: function children(e) {
              var t = s(h, c, r);
              return t ? t(e) : null;
            }
          }));
        });
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(e, t) {
        var n = t.first,
            o = t.prevProps,
            a = r(t, ["first", "prevProps"]),
            s = Fe(e),
            l = s.items,
            u = s.keys,
            c = s.initial,
            d = s.from,
            h = s.enter,
            m = s.leave,
            f = s.update,
            p = s.trail,
            g = void 0 === p ? 0 : p,
            v = s.unique,
            b = s.config,
            _ = Fe(o),
            y = _.keys,
            k = _.items,
            w = i({}, a.current),
            x = _toConsumableArray(a.deleted),
            E = Object.keys(w),
            M = new Set(E),
            S = new Set(u),
            T = u.filter(function (e) {
          return !M.has(e);
        }),
            C = a.transitions.filter(function (e) {
          return !e.destroyed && !S.has(e.originalKey);
        }).map(function (e) {
          return e.originalKey;
        }),
            D = u.filter(function (e) {
          return M.has(e);
        }),
            A = 0;

        T.forEach(function (e) {
          v && x.find(function (t) {
            return t.originalKey === e;
          }) && (x = x.filter(function (t) {
            return t.originalKey !== e;
          }));
          var t = u.indexOf(e),
              r = l[t];
          w[e] = {
            state: "enter",
            originalKey: e,
            key: v ? String(e) : Oe++,
            item: r,
            trail: A += g,
            config: ae(b, r, "enter"),
            from: ae(n && void 0 !== c ? c || {} : d, r),
            to: ae(h, r)
          };
        }), C.forEach(function (e) {
          var t = y.indexOf(e),
              n = k[t];
          x.push(i({}, w[e], {
            state: "leave",
            destroyed: !0,
            left: y[Math.max(0, t - 1)],
            right: y[Math.min(y.length, t + 1)],
            trail: A += g,
            config: ae(b, n, "leave"),
            to: ae(m, n)
          })), delete w[e];
        }), D.forEach(function (e) {
          var t = u.indexOf(e),
              n = l[t];
          w[e] = i({}, w[e], {
            item: n,
            state: "update",
            trail: A += g,
            config: ae(b, n, "update"),
            to: ae(f, n)
          });
        });
        var O = u.map(function (e) {
          return w[e];
        });
        return x.forEach(function (e) {
          var t,
              n = e.left,
              i = e.right,
              o = r(e, ["left", "right"]);
          -1 !== (t = O.findIndex(function (e) {
            return e.originalKey === n;
          })) && (t += 1), -1 === t && (t = O.findIndex(function (e) {
            return e.originalKey === i;
          })), -1 === t && (t = x.findIndex(function (e) {
            return e.originalKey === n;
          })), -1 === t && (t = x.findIndex(function (e) {
            return e.originalKey === i;
          })), t = Math.max(0, t), O = [].concat(_toConsumableArray(O.slice(0, t)), [o], _toConsumableArray(O.slice(t)));
        }), {
          first: n && 0 === T.length,
          transitions: O,
          current: w,
          deleted: x,
          prevProps: e
        };
      }
    }]);

    return Re;
  }(o.PureComponent);

  Re.defaultProps = {
    keys: function keys(e) {
      return e;
    },
    unique: !1,
    reset: !1
  };
  var Ne = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].reduce(function (e, t) {
    return e[t] = Me(t), e;
  }, Me);
  t.Spring = Te, t.Keyframes = Ae, t.Transition = Re, t.Trail = Ce, t.Controller = xe, t.config = Se, t.animated = Ne, t.interpolate = function (e, t, n) {
    return e && new ee(e, t, n);
  }, t.Globals = x;
});
l(Gr);
var Zr = Gr.Spring,
    $r = (Gr.Keyframes, Gr.Transition),
    Jr = (Gr.Trail, Gr.Controller, Gr.config, Gr.animated),
    Kr = (Gr.interpolate, Gr.Globals, "bookmark-module_Bookmark__-HTkX"),
    Qr = "bookmark-module__immediate__fNcSt",
    ei = "bookmark-module_main__3uHzE",
    ti = "bookmark-module__compact__1OTgr",
    ni = "bookmark-module__overflowingRight__1uTZj",
    ri = "bookmark-module__overflowingLeft__1WtIx",
    ii = "bookmark-module_delete__2EY2k",
    oi = "bookmark-module_title__3fARy",
    ai = "bookmark-module_leftArrow__1C0D4",
    si = "bookmark-module_rightArrow__2CQmj",
    li = "bookmark-module_icon__3L4Tz",
    ui = "bookmark-module__point__3C9rA";

function ci() {
  return (ci = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

k(".bookmark-module_Bookmark__-HTkX {\n  box-sizing: border-box;\n  position: absolute;\n  bottom: var(--timebar-size);\n  display: flex;\n  margin-bottom: 0.5rem;\n  transition: var(--timebar-hover-transition);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n\n  /* z-index: -2; */\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__immediate__fNcSt {\n  transition: none;\n}\n\n.bookmark-module_Bookmark__-HTkX button {\n  background: var(--timebar-ui-btn-color-faded);\n  border: none;\n  padding: 0;\n  height: 3rem;\n  cursor: pointer;\n}\n\n.bookmark-module_Bookmark__-HTkX button:focus {\n  outline: none;\n}\n\n.bookmark-module_Bookmark__-HTkX button:hover {\n  background: var(--timebar-ui-btn-color);\n}\n\nbutton.bookmark-module_main__3uHzE {\n  display: flex;\n  flex: auto;\n  align-items: center;\n  text-align: left;\n  padding: 0 1rem;\n  border-top-left-radius: 0.4rem;\n  border-bottom-left-radius: 0.4rem;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__compact__1OTgr .bookmark-module_main__3uHzE {\n  border-top-right-radius: 0.4rem;\n  border-bottom-right-radius: 0.4rem;\n  justify-content: space-between;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__overflowingRight__1uTZj .bookmark-module_main__3uHzE {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__overflowingLeft__1WtIx .bookmark-module_main__3uHzE {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\nbutton.bookmark-module_delete__2EY2k {\n  color: var(--timebar-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  border-left: 0.1rem solid var(--timebar-white);\n  margin-left: auto;\n  border-top-right-radius: 0.4rem;\n  border-bottom-right-radius: 0.4rem;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__overflowingRight__1uTZj .bookmark-module_delete__2EY2k {\n  border-radius: 0;\n}\n\n.bookmark-module_title__3fARy {\n  flex: auto;\n  margin-left: 0.8rem;\n  font-family: var(--timebar-font-family);\n  font-size: var(--timebar-font-size);\n  font-weight: var(--timebar-font-weight);\n  color: var(--timebar-white);\n  text-transform: uppercase;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__overflowingLeft__1WtIx .bookmark-module_leftArrow__1C0D4 {\n  margin-right: 0.8rem;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__overflowingRight__1uTZj .bookmark-module_rightArrow__2CQmj {\n  margin-right: 0.8rem;\n  transform: rotateZ(180deg);\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__compact__1OTgr .bookmark-module_icon__3L4Tz {\n  flex: 0 auto;\n}\n\n.bookmark-module_Bookmark__-HTkX.bookmark-module__point__3C9rA::after {\n  content: '';\n  position: absolute;\n  left: 11px;\n  bottom: -5px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: var(--timebar-ui-btn-color-faded) transparent transparent transparent;\n}\n");

var di = h.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.5,
  fill: "#FFF",
  d: "M1 1h9v12l-4.5-3L1 13z",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}),
    hi = function hi(e) {
  return h.createElement("svg", ci({
    width: 11,
    height: 14
  }, e), di);
};

function mi() {
  return (mi = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var fi = h.createElement("path", {
  d: "M10.477.738V2.25H0V.738h2.602L3.375 0h3.727l.773.738h2.602zM.738 11.988v-9h9v9c0 .399-.152.75-.457 1.055-.304.305-.656.457-1.054.457H2.25c-.398 0-.75-.152-1.055-.457-.304-.305-.457-.656-.457-1.055z",
  fill: "#FFF",
  fillRule: "evenodd"
}),
    pi = function pi(e) {
  return h.createElement("svg", mi({
    width: 11,
    height: 14
  }, e), fi);
};

function gi() {
  return (gi = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var vi = h.createElement("path", {
  d: "M5 1L1 5l4 4",
  stroke: "#FFF",
  strokeWidth: 1.5,
  fill: "none"
}),
    bi = function bi(e) {
  return h.createElement("svg", gi({
    width: 6,
    height: 10
  }, e), vi);
},
    _i = function (e) {
  function a() {
    return n(this, a), r(this, i(a).apply(this, arguments));
  }

  return t(a, m), s(a, [{
    key: "render",
    value: function value() {
      var e,
          t,
          n,
          r,
          i = this.props,
          a = i.scale,
          s = i.bookmarkStart,
          l = i.bookmarkEnd,
          u = i.minX,
          c = i.maxX,
          d = i.onSelect,
          m = this.context.immediate,
          f = a(new Date(s)),
          p = a(new Date(l)) - f,
          g = E(s, l),
          v = [g.humanizedStart, g.humanizedEnd].join(" - "),
          b = f,
          _ = p;
      f < u && (b = u, _ = f + _, t = !0, n = !0), b + p > c && (_ = c - (b = Math.min(b, c - 52)), t = !0, r = !0);
      var y = !0 === t ? 52 : 32,
          k = (_ = Math.max(y, _)) < 240,
          w = _ <= 32;
      return h.createElement("div", {
        className: N(Kr, (e = {}, o(e, ri, n), o(e, ni, r), o(e, ti, k), o(e, ui, w), o(e, Qr, m), e)),
        style: {
          left: b,
          width: _
        }
      }, h.createElement("button", {
        type: "button",
        title: "Go to time range bookmark",
        className: ei,
        onClick: d
      }, n && h.createElement(bi, {
        className: ai
      }), h.createElement(hi, {
        className: li
      }), !1 === k && h.createElement("span", {
        className: oi
      }, v), r && h.createElement(bi, {
        className: si
      })), !1 === k && h.createElement("button", {
        type: "button",
        title: "Delete time range bookmark",
        className: ii,
        onClick: this.props.onDelete
      }, h.createElement(pi, null)));
    }
  }]), a;
}();

o(_i, "contextType", j), _i.propTypes = {
  bookmarkStart: p.string.isRequired,
  bookmarkEnd: p.string.isRequired,
  scale: p.func.isRequired,
  minX: p.number.isRequired,
  maxX: p.number.isRequired,
  immediate: p.bool.isRequired,
  onSelect: p.func.isRequired,
  onDelete: p.func.isRequired
};
var yi = "timeline-units-module_unit__3a0O6";
k(".timeline-units-module_unit__3a0O6 {\n  position: absolute;\n  height: 100%;\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  border-right: 0.1rem solid rgba(255, 255, 255, 0.2);\n}\n\n.timeline-units-module_unit__3a0O6:first-child {\n  border-left: 0.1rem solid rgba(255, 255, 255, 0.2);\n}\n\n.timeline-units-module_unit__3a0O6 button,\n.timeline-units-module_unit__3a0O6 div {\n  width: 100%;\n  padding: 0;\n  text-align: center;\n  line-height: 1.4rem;\n  text-transform: uppercase;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  color: var(--timebar-light-blue);\n  font-size: var(--timebar-small-font-size);\n  font-weight: 400;\n  font-family: var(--timebar-font-family);\n}\n\n.timeline-units-module_unit__3a0O6 button {\n  background: none;\n  border: none;\n  cursor: zoom-in;\n  z-index: 1;\n}\n\n.timeline-units-module_unit__3a0O6 button:focus {\n  outline: 0;\n}\n\n.timeline-units-module_unit__3a0O6 button:hover {\n  outline: 0;\n  color: var(--timebar-white);\n  background-image:\n    linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n@media only screen and (max-width: 460px) {\n  .timeline-units-module_unit__3a0O6 {\n    align-items: center;\n  }\n\n  .timeline-units-module_unit__3a0O6 span {\n    height: var(--timebar-size);\n    line-height: var(--timebar-size);\n  }\n}\n");

var ki = function (e) {
  function o() {
    return n(this, o), r(this, i(o).apply(this, arguments));
  }

  return t(o, m), s(o, [{
    key: "zoomToUnit",
    value: function value(e) {
      var t = e.start,
          n = e.end;
      this.props.onChange(t, n);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.start,
          r = t.end,
          i = t.absoluteStart,
          o = t.absoluteEnd,
          a = t.outerScale,
          s = t.outerStart,
          l = t.outerEnd,
          u = this.context.immediate,
          c = M(n, r),
          d = "day";
      c > 366 ? d = "year" : c > 31 ? d = "month" : c < 1 && (d = "hour");
      var m = S(a, s, l, i, o, d);
      return h.createElement("div", null, h.createElement($r, {
        native: !0,
        immediate: u,
        items: m,
        keys: m.map(function (e) {
          return e.id;
        }),
        from: {
          opacity: 0
        },
        leave: {
          opacity: 0
        },
        enter: function enter(e) {
          return {
            left: e.x,
            width: e.width,
            opacity: 1
          };
        },
        update: function update(e) {
          return {
            left: e.x,
            width: e.width,
            opacity: 1
          };
        }
      }, function (t) {
        return function (n) {
          return h.createElement(Jr.div, {
            style: n,
            className: yi
          }, "hour" === d ? h.createElement(Jr.div, null, t.label) : h.createElement(Jr.button, {
            type: "button",
            onClick: function onClick() {
              e.zoomToUnit(t);
            },
            title: t.hoverLabel
          }, t.label));
        };
      }));
    }
  }]), o;
}();

o(ki, "contextType", j), ki.propTypes = {
  onChange: p.func.isRequired,
  start: p.string.isRequired,
  end: p.string.isRequired,
  absoluteStart: p.string.isRequired,
  absoluteEnd: p.string.isRequired,
  outerStart: p.string.isRequired,
  outerEnd: p.string.isRequired,
  outerScale: p.func.isRequired
};
var wi = "timeline-handler-module_handler__1dvGx",
    xi = "timeline-handler-module__immediate__31Pvd";

function Ei() {
  return (Ei = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

k(".timeline-handler-module_handler__1dvGx {\n  border: none;\n  padding: 0;\n  background: var(--timebar-ui-btn-color);\n  color: var(--timebar-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0.5rem;\n  bottom: 0.5rem;\n  left: 15%;\n  transform: translateX(-50%);\n  border-radius: 0.4rem;\n  width: 1.7rem;\n  box-shadow: 0 0 7px 0 rgba(0, 16, 57, 0.7);\n  cursor: move; /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -webkit-grab;\n  z-index: 2;\n  transition: var(--timebar-hover-transition);\n}\n\n/*\n.handler::after {\n  background: red;\n  content: ' ';\n  width: 1px;\n  height: 80px;\n  position: absolute;\n} */\n\n.timeline-handler-module_handler__1dvGx.timeline-handler-module__immediate__31Pvd {\n  transition: none;\n}\n\n.timeline-handler-module_handler__1dvGx:hover,\n.timeline-handler-module_handler__1dvGx:focus {\n  background: var(--timebar-ui-btn-color-hover);\n  outline: none;\n}\n\n@media only screen and (max-width: 460px) {\n  .timeline-handler-module_handler__1dvGx {\n    width: 2.4rem;\n  }\n}\n");

var Mi = h.createElement("path", {
  d: "M4 1L1 5l3 4m3-8l3 4-3 4",
  stroke: "#FFF",
  strokeWidth: 1.5,
  fill: "none"
}),
    Si = function Si(e) {
  return h.createElement("svg", Ei({
    width: 11,
    height: 10
  }, e), Mi);
},
    Ti = function Ti(e) {
  return h.createElement("button", {
    onMouseDown: e.onMouseDown,
    onTouchStart: e.onMouseDown,
    type: "button",
    title: "Drag to change the time range",
    className: N(wi, o({}, xi, !0 === e.dragging)),
    style: {
      left: !0 === e.dragging ? e.mouseX : e.x
    }
  }, h.createElement(Si, null));
};

Ti.propTypes = {
  onMouseDown: p.func.isRequired,
  dragging: p.bool.isRequired,
  x: p.number.isRequired,
  mouseX: p.number
}, Ti.defaultProps = {
  mouseX: 0
};
var Ci = "timeline-module_Timeline__1WaGp",
    Di = "timeline-module_graphContainer__DfKZ0",
    Ai = "timeline-module_graph__2lqP4",
    Oi = "timeline-module_veil__2mFdz",
    Fi = "timeline-module_veilLeft__vS5Rh",
    Ri = "timeline-module_veilRight__2Eusj",
    Ni = "timeline-module__immediate__1XDQw",
    ji = "timeline-module_absoluteEnd__2vLJz",
    Pi = "timeline-module_lastUpdate__1BeD3",
    zi = "timeline-module_lastUpdateLabel__3GJvD";
k(".timeline-module_Timeline__1WaGp {\n  width: 100%;\n  background-position-y: 1rem;\n  position: relative;\n  z-index: 0;\n}\n\n.timeline-module_graphContainer__DfKZ0 {\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.timeline-module_graph__2lqP4 {\n  position: relative;\n  height: 100%;\n  display: flex;\n  cursor: move; /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -webkit-grab;\n}\n\n.timeline-module_veil__2mFdz {\n  position: absolute;\n  height: 100%;\n  top: 0;\n  transition: var(--timebar-hover-transition);\n  z-index: 1;\n  pointer-events: all;\n}\n\n.timeline-module_veilLeft__vS5Rh {\n  width: 15%;\n  background-image:\n    linear-gradient(\n      90deg,\n      var(--timebar-main-background-color) 0%,\n      rgba(0, 16, 57, 0.3) 100%\n    );\n}\n\n.timeline-module_veilRight__2Eusj {\n  right: 0;\n  width: 15.01%;\n  background-image:\n    linear-gradient(\n      90deg,\n      rgba(0, 16, 57, 0.3) 0%,\n      var(--timebar-main-background-color) 100%\n    );\n}\n\n.timeline-module_veil__2mFdz.timeline-module__immediate__1XDQw {\n  transition: none;\n}\n\n.timeline-module_absoluteEnd__2vLJz {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  top: 0;\n  padding-left: 2rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  font-weight: 400;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.timeline-module_lastUpdate__1BeD3 {\n  font-size: 1.4rem;\n}\n\n.timeline-module_lastUpdateLabel__3GJvD {\n  text-transform: uppercase;\n  opacity: 0.4;\n  font-size: 1.2rem;\n}\n");

var Ui = "DRAG_INNER",
    qi = "DRAG_START",
    Ii = "DRAG_END",
    Li = function (e) {
  function l() {
    var e;
    return n(this, l), e = r(this, i(l).call(this)), o(a(e), "onWindowResize", function () {
      if (null !== e.graphContainer) {
        var t = window.getComputedStyle(e.graphContainer),
            n = parseFloat(e.graphContainer.getBoundingClientRect().left),
            r = parseFloat(t.width),
            i = parseFloat(t.height),
            o = .15 * r,
            a = .85 * r,
            s = .7 * r;
        e.setState({
          outerX: n,
          innerStartPx: o,
          innerEndPx: a,
          innerWidth: s,
          outerWidth: r,
          outerHeight: i
        });
      }
    }), o(a(e), "onEnterFrame", function (t) {
      void 0 === e.frameTimestamp && (e.frameTimestamp = t);
      var n = t - e.frameTimestamp;

      if (e.frameTimestamp = t, !0 === e.state.outerDrag) {
        var r = e.state,
            i = r.dragging,
            o = r.innerStartPx,
            a = r.innerEndPx,
            s = r.outerWidth,
            l = r.handlerMouseX,
            u = e.props,
            c = u.start,
            d = u.end,
            h = u.absoluteStart,
            m = u.absoluteEnd,
            f = u.onChange,
            p = i === qi ? (o - l) / o : (l - a) / (s - a),
            g = (e.innerScale.invert(.6).getTime() - e.innerScale.invert(0).getTime()) * n * p,
            v = c,
            b = d;
        i === qi ? v = new Date(x(c) - g).toISOString() : i === Ii && (b = new Date(x(d) + g).toISOString());

        var _ = T(v, b, C(c, d), h, m);

        f(_.newStartClamped, _.newEndClamped);
      }

      e.requestAnimationFrame = window.requestAnimationFrame(e.onEnterFrame);
    }), o(a(e), "onMouseDown", function (t, n) {
      var r = e.state.outerX,
          i = t.clientX || t.changedTouches[0].clientX;
      e.lastX = i;
      var o = i - r;
      e.context.toggleImmediate(!0), e.setState({
        dragging: n,
        handlerMouseX: o
      });
    }), o(a(e), "throttledMouseMove", O(function (t, n, r) {
      e.props.onMouseMove(t, n, r);
    }, 16)), o(a(e), "onMouseMove", function (t) {
      var n = e.props,
          r = n.start,
          i = n.end,
          o = n.absoluteStart,
          a = n.absoluteEnd,
          s = n.onChange,
          l = n.onMouseLeave,
          u = e.state,
          c = u.dragging,
          d = u.outerX,
          h = u.innerStartPx,
          m = u.innerEndPx,
          f = t.clientX || t.changedTouches && t.changedTouches[0].clientX;

      if (void 0 !== f) {
        var p = f - d;

        if (e.node.contains(t.target) && p > h && p < m) {
          e.isMovingInside = !0;
          var g = !D(r, i);
          e.throttledMouseMove(p, e.outerScale.invert, g);
        } else !0 === e.isMovingInside && (e.isMovingInside = !1, l());

        if (c === Ui) {
          var v = C(r, i),
              b = f - e.lastX;
          e.lastX = t.clientX || t.changedTouches[0].clientX;

          var _ = e.innerScale.invert(-b),
              y = new Date(_.getTime() + v),
              k = T(_.toISOString(), y.toISOString(), v, o, a);

          s(k.newStartClamped, k.newEndClamped);
        } else !0 === e.isHandlerZoomInValid(p).isValid ? e.setState({
          handlerMouseX: p,
          outerDrag: !1
        }) : !0 === e.isHandlerZoomOutValid(p) && e.setState({
          handlerMouseX: p,
          outerDrag: !0
        });
      }
    }), o(a(e), "onMouseUp", function (t) {
      var n = e.props,
          r = n.start,
          i = n.end,
          o = n.onChange,
          a = e.state,
          s = a.dragging,
          l = a.outerX,
          u = a.innerStartPx;

      if (null !== s) {
        var c = (t.clientX || t.changedTouches[0].clientX) - l,
            d = e.isHandlerZoomInValid(c);
        e.context.toggleImmediate(!1), e.setState({
          dragging: null,
          handlerMouseX: null,
          outerDrag: !1
        });
        var h = r,
            m = i;
        d.isZoomIn && (s === qi ? h = e.innerScale.invert(d.clampedX - u).toISOString() : s === Ii && (m = e.innerScale.invert(d.clampedX - u).toISOString()));
        var f = D(h, m) ? "day" : "hour";
        o(h = A(h, f), m = A(m, f));
      }
    }), e.state = {
      innerStartPx: 0,
      innerEndPx: 0,
      innerWidth: 50,
      outerWidth: 100,
      outerHeight: 50,
      dragging: null
    }, e.graphContainer = null, e.isMovingInside = !1, e;
  }

  return t(l, m), s(l, [{
    key: "componentDidMount",
    value: function value() {
      window.setTimeout(this.onWindowResize, 10), window.addEventListener("resize", this.onWindowResize), window.addEventListener("mousemove", this.onMouseMove), window.addEventListener("touchmove", this.onMouseMove), window.addEventListener("mouseup", this.onMouseUp), window.addEventListener("touchend", this.onMouseUp), this.requestAnimationFrame = window.requestAnimationFrame(this.onEnterFrame);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("resize", this.onWindowResize), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onMouseMove), window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("touchend", this.onMouseUp), window.cancelAnimationFrame(this.requestAnimationFrame);
    }
  }, {
    key: "isHandlerZoomInValid",
    value: function value(e) {
      var t = this.state,
          n = t.dragging,
          r = t.innerStartPx,
          i = t.innerEndPx,
          o = n === qi && e > r || n === Ii && e < i;
      return {
        isZoomIn: o,
        isValid: o && (n === qi && e < i - 20 || n === Ii && e > r + 20),
        clampedX: n === qi ? Math.min(e, i - 20) : Math.max(e, r + 20)
      };
    }
  }, {
    key: "isHandlerZoomOutValid",
    value: function value(e) {
      var t = this.state,
          n = t.dragging,
          r = t.innerStartPx,
          i = t.innerEndPx,
          o = t.outerWidth;
      return n === qi && e < r && e > 0 || n === Ii && e > i && e < o;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.start,
          r = t.end,
          i = t.absoluteEnd,
          a = t.bookmarkStart,
          s = t.bookmarkEnd,
          l = t.onChange,
          d = t.onBookmarkChange,
          m = this.state,
          f = m.dragging,
          p = m.handlerMouseX,
          g = m.innerStartPx,
          v = m.innerEndPx,
          b = m.innerWidth,
          _ = m.outerX,
          y = m.outerWidth,
          k = m.outerHeight,
          x = this.context.immediate;
      this.innerScale = Br().domain([new Date(n), new Date(r)]).range([0, b]);
      var E = this.innerScale.invert(-g).toISOString(),
          M = this.innerScale.invert(y - g).toISOString();
      this.outerScale = Br().domain([new Date(E), new Date(M)]).range([0, this.state.outerWidth]);
      var S = this.outerScale(new Date(i));
      return h.createElement("div", {
        ref: function ref(t) {
          return e.node = t;
        },
        className: Ci
      }, null != a && h.createElement(_i, {
        scale: this.outerScale,
        bookmarkStart: a,
        bookmarkEnd: s,
        minX: -_,
        maxX: y,
        onDelete: function onDelete() {
          d(null, null);
        },
        onSelect: function onSelect() {
          l(a, s);
        }
      }), h.createElement("div", {
        className: Di,
        ref: function ref(t) {
          e.graphContainer = t;
        }
      }, h.createElement("div", {
        className: Ai,
        onMouseDown: function onMouseDown(t) {
          e.onMouseDown(t, Ui);
        },
        onTouchStart: function onTouchStart(t) {
          e.onMouseDown(t, Ui);
        }
      }, h.createElement(ki, u({}, this.props, {
        outerScale: this.outerScale,
        outerStart: E,
        outerEnd: M
      })), this.props.children && this.props.children(c({
        outerScale: this.outerScale,
        outerStart: E,
        outerEnd: M,
        outerWidth: y,
        outerHeight: k,
        graphHeight: k,
        tooltipContainer: this.tooltipContainer
      }, this.props)))), h.createElement("div", {
        ref: function ref(t) {
          e.tooltipContainer = t;
        }
      }), h.createElement("div", {
        className: N(Fi, Oi, o({}, Ni, f === qi)),
        style: {
          width: f === qi ? p : g
        }
      }), h.createElement(Ti, {
        onMouseDown: function onMouseDown(t) {
          e.onMouseDown(t, qi);
        },
        onTouchStart: function onTouchStart(t) {
          e.onMouseDown(t, qi);
        },
        dragging: this.state.dragging === qi,
        x: g,
        mouseX: this.state.handlerMouseX
      }), h.createElement(Ti, {
        onMouseDown: function onMouseDown(t) {
          e.onMouseDown(t, Ii);
        },
        onTouchStart: function onTouchStart(t) {
          e.onMouseDown(t, Ii);
        },
        dragging: this.state.dragging === Ii,
        x: v,
        mouseX: this.state.handlerMouseX
      }), h.createElement("div", {
        className: N(Ri, Oi, o({}, Ni, f === Ii)),
        style: {
          left: f === Ii ? p : v,
          width: f === Ii ? y - p : y - v
        }
      }), S <= y && h.createElement(Zr, {
        native: !0,
        immediate: x,
        to: {
          left: S
        }
      }, function (e) {
        return h.createElement(Jr.div, {
          className: ji,
          style: e
        }, h.createElement("div", {
          className: N(Pi, zi)
        }, "Last Update"), h.createElement("div", {
          className: Pi
        }, w(i).format("MMMM D YYYY")));
      }));
    }
  }]), l;
}();

function Hi(e, t) {
  if (e.length !== t.length) return !1;

  for (var n = 0; n < e.length; n++) {
    if (e[n] !== t[n]) return !1;
  }

  return !0;
}

function Vi(e, t) {
  var n;
  void 0 === t && (t = Hi);
  var r,
      i = [],
      o = !1;
  return function () {
    for (var a = [], s = 0; s < arguments.length; s++) {
      a[s] = arguments[s];
    }

    return o && n === this && t(a, i) ? r : (r = e.apply(this, a), o = !0, n = this, i = a, r);
  };
}

function Xi() {
  return (Xi = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

o(Li, "contextType", j), Li.propTypes = {
  onChange: p.func.isRequired,
  onMouseLeave: p.func,
  onMouseMove: p.func,
  children: p.func.isRequired,
  start: p.string.isRequired,
  end: p.string.isRequired,
  absoluteStart: p.string.isRequired,
  absoluteEnd: p.string.isRequired,
  onBookmarkChange: p.func,
  bookmarkStart: p.string,
  bookmarkEnd: p.string
}, Li.defaultProps = {
  bookmarkStart: null,
  bookmarkEnd: null,
  onBookmarkChange: function onBookmarkChange() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseMove: function onMouseMove() {}
};

var Bi = h.createElement("path", {
  d: "M6 12v-2l2.66 2.66L6 15.34v-2a5.14 5.14 0 01-3.77-1.57A5.14 5.14 0 01.66 8c0-1.04.28-1.99.84-2.84l.97.96A3.8 3.8 0 002 8c0 1.1.4 2.05 1.17 2.83A3.85 3.85 0 006 12zm0-9.34c1.46 0 2.71.52 3.77 1.57A5.14 5.14 0 0111.34 8c0 1.04-.28 1.99-.84 2.84l-.97-.96A3.8 3.8 0 0010 8c0-1.1-.4-2.05-1.17-2.83A3.85 3.85 0 006 4v2L3.34 3.34 6 .66v2z",
  fillRule: "evenodd"
}),
    Wi = function Wi(e) {
  return h.createElement("svg", Xi({
    width: 12,
    height: 16
  }, e), Bi);
};

function Yi() {
  return (Yi = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var Gi = h.createElement("path", {
  d: "M7 0v7L2 3.5 7 0zM1 0v7H0V0h1z",
  fill: "#FFF",
  fillRule: "evenodd"
}),
    Zi = function Zi(e) {
  return h.createElement("svg", Yi({
    width: 7,
    height: 7
  }, e), Gi);
};

function $i() {
  return ($i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var Ji = h.createElement("path", {
  d: "M.5 1.79v12.42a.5.5 0 00.762.426l10.092-6.21a.5.5 0 000-.852L1.262 1.364A.5.5 0 00.5 1.79z",
  fill: "#FFF",
  stroke: "#FFF",
  fillRule: "evenodd"
}),
    Ki = function Ki(e) {
  return h.createElement("svg", $i({
    width: 13,
    height: 16
  }, e), Ji);
};

function Qi() {
  return (Qi = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var eo = h.createElement("path", {
  d: "M0 0h3.077v11H0V0zm6.923 0H10v11H6.923V0z",
  fill: "#FFF"
}),
    to = function to(e) {
  return h.createElement("svg", Qi({
    width: 10,
    height: 11
  }, e), eo);
};

function no() {
  return (no = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var ro = h.createElement("path", {
  d: "M0 0l5 3.5L0 7V0zm6 0h1v7H6V0z",
  fill: "#FFF",
  fillRule: "evenodd"
}),
    io = function io(e) {
  return h.createElement("svg", no({
    width: 7,
    height: 7
  }, e), ro);
},
    oo = {
  playbackActions: "playback-module_playbackActions__3S8Ab",
  secondary: "playback-module_secondary__KmJaW",
  playbackActionsActive: "playback-module_playbackActionsActive__3EWNw",
  secondaryActive: "playback-module_secondaryActive__3u5tO",
  buttonBigger: "playback-module_buttonBigger__xC6ca",
  loop: "playback-module_loop__1tCjJ",
  speed: "playback-module_speed__2VjvT"
};

k(".playback-module_playbackActions__3S8Ab svg {\n  fill: var(--timebar-white);\n}\n\n/* PLAYBACK ACTIONS */\n\n.playback-module_playbackActions__3S8Ab {\n  background-color: var(--timebar-ui-btn-color);\n  width: var(--timebar-size);\n  height: 100%;\n  margin-right: 0.1rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.playback-module_secondary__KmJaW {\n  opacity: 0;\n}\n\n.playback-module_playbackActionsActive__3EWNw .playback-module_secondary__KmJaW,\n.playback-module_playbackActions__3S8Ab:hover .playback-module_secondary__KmJaW {\n  opacity: 0.5;\n}\n\n.playback-module_playbackActions__3S8Ab .playback-module_secondaryActive__3u5tO,\n.playback-module_playbackActions__3S8Ab:hover .playback-module_secondary__KmJaW:hover {\n  opacity: 1;\n}\n\n.playback-module_playbackActions__3S8Ab button {\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 50%;\n}\n\n.playback-module_playbackActions__3S8Ab .playback-module_buttonBigger__xC6ca:hover,\n.playback-module_playbackActions__3S8Ab .playback-module_buttonBigger__xC6ca:focus {\n  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1);\n  z-index: 1;\n}\n\n.playback-module_playbackActions__3S8Ab .playback-module_loop__1tCjJ,\n.playback-module_playbackActions__3S8Ab .playback-module_speed__2VjvT {\n  margin: 0 2.4rem;\n}\n\n@media only screen and (max-width: 72rem) {\n  .playback-module_playbackActions__3S8Ab {\n    display: none;\n  }\n}\n");

var ao = .001,
    so = [1, 2, 3, 5, 10],
    lo = 100,
    uo = function (e) {
  function l() {
    var e;
    return n(this, l), e = r(this, i(l).call(this)), o(a(e), "lastUpdateMs", null), o(a(e), "getStep", Vi(function (e, t, n) {
      var r = ao * so[n],
          i = new Date(e).getTime(),
          o = new Date(t).getTime();
      return Gt().range([0, 1]).domain([i, o]).invert(r) - i;
    })), o(a(e), "update", function (t) {
      var n = e.props,
          r = n.onTick,
          i = n.start,
          o = n.end,
          a = n.absoluteStart,
          s = n.absoluteEnd,
          l = e.state,
          u = l.speedStep,
          c = l.loop,
          d = e.getStep(i, o, u) * t,
          h = new Date(i).getTime() + d,
          m = new Date(o).getTime() + d,
          f = m - h,
          p = new Date(h).toISOString(),
          g = new Date(m).toISOString(),
          v = T(p, g, f, a, s),
          b = v.newStartClamped,
          _ = v.newEndClamped,
          y = v.clamped;
      (r(b, _), "end" === y) && (!0 === c ? r(a, new Date(new Date(a).getTime() + f).toISOString()) : e.togglePlay(!1));
      if ("end" !== y || !0 === c) return !0;
    }), o(a(e), "tick", function (t) {
      null === e.lastUpdateMs && (e.lastUpdateMs = t);
      var n = (t - e.lastUpdateMs) / (1e3 / 60),
          r = e.update(n);
      e.lastUpdateMs = t, !0 === r && (e.requestAnimationFrame = window.requestAnimationFrame(e.tick));
    }), o(a(e), "togglePlay", function (t) {
      var n = e.state.playing,
          r = void 0 === t ? !n : t;
      r ? (e.context.toggleImmediate(!0), e.requestAnimationFrame = window.requestAnimationFrame(e.tick)) : (e.context.toggleImmediate(!1), e.lastUpdateMs = null, window.cancelAnimationFrame(e.requestAnimationFrame)), e.setState({
        playing: r
      });
    }), o(a(e), "onPlayToggleClick", function () {
      e.togglePlay();
    }), o(a(e), "toggleLoop", function () {
      e.setState(function (e) {
        return {
          loop: !e.loop
        };
      });
    }), o(a(e), "onForwardClick", function () {
      e.update(lo);
    }), o(a(e), "onBackwardClick", function () {
      e.update(-lo);
    }), o(a(e), "onSpeedClick", function () {
      var t = e.state.speedStep,
          n = t === so.length - 1 ? 0 : t + 1;
      e.setState({
        speedStep: n
      });
    }), e.state = {
      playing: !1,
      speedStep: 0,
      loop: !1
    }, e;
  }

  return t(l, m), s(l, [{
    key: "componentWillUnmount",
    value: function value() {
      window.cancelAnimationFrame(this.requestAnimationFrame);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.state,
          t = e.playing,
          n = e.loop,
          r = e.speedStep;
      return h.createElement("div", {
        className: N(oo.playbackActions, o({}, oo.playbackActionsActive, t))
      }, h.createElement("button", {
        type: "button",
        title: "Toggle animation looping",
        onClick: this.toggleLoop,
        className: N(P.uiButton, oo.secondary, oo.loop, o({}, oo.secondaryActive, n))
      }, h.createElement(Wi, null)), h.createElement("button", {
        type: "button",
        title: "Move back",
        onClick: this.onBackwardClick,
        className: N(P.uiButton, oo.secondary, oo.back)
      }, h.createElement(Zi, null)), h.createElement("button", {
        type: "button",
        title: "".concat(!0 === t ? "Pause" : "Play", " animation"),
        onClick: this.onPlayToggleClick,
        className: N(P.uiButton, oo.buttonBigger, oo.play)
      }, !0 === t ? h.createElement(to, null) : h.createElement(Ki, null)), h.createElement("button", {
        type: "button",
        title: "Move forward",
        onClick: this.onForwardClick,
        className: N(P.uiButton, oo.secondary, oo.forward)
      }, h.createElement(io, null)), h.createElement("button", {
        type: "button",
        title: "Change animation speed",
        onClick: this.onSpeedClick,
        className: N(P.uiButton, oo.secondary, oo.speed)
      }, so[r], "x"));
    }
  }]), l;
}();

function co() {
  return (co = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

o(uo, "contextType", j), uo.propTypes = {
  onTick: p.func.isRequired,
  start: p.string.isRequired,
  end: p.string.isRequired,
  absoluteStart: p.string.isRequired,
  absoluteEnd: p.string.isRequired
};

var ho = h.createElement("path", {
  fill: "#FFF",
  d: "M1.06 5v8a1 1 0 001 1h11a1 1 0 001-1V5h-13zm14-2v10a2 2 0 01-2 2h-11a2 2 0 01-2-2V3c0-1.1.9-2 2-2v.5a1.5 1.5 0 003 0V1h5v.5a1.5 1.5 0 003 0V1a2 2 0 012 2zm-9 4v5l-3-2.5 3-2.5zm3 0v5l3-2.5-3-2.5zm-5.5-7a.5.5 0 00-.5.5v1a.5.5 0 001 0v-1a.5.5 0 00-.5-.5zm8 0a.5.5 0 00-.5.5v1a.5.5 0 101 0v-1a.5.5 0 00-.5-.5z"
}),
    mo = function mo(e) {
  return h.createElement("svg", co({
    width: 16,
    height: 15
  }, e), ho);
};

function fo() {
  return (fo = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var po = h.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.5,
  d: "M1 1h9v12l-4.5-3L1 13z",
  fill: "none",
  strokeLinejoin: "round"
}),
    go = function go(e) {
  return h.createElement("svg", fo({
    width: 11,
    height: 14
  }, e), po);
};

function vo() {
  return (vo = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var bo = h.createElement("rect", {
  width: 7,
  height: 1,
  rx: .5,
  transform: "translate(1 1)",
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: .5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}),
    _o = function _o(e) {
  return h.createElement("svg", vo({
    width: 9,
    height: 3
  }, e), bo);
};

function yo() {
  return (yo = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var ko = h.createElement("g", {
  transform: "translate(1 1)",
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: .5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, h.createElement("rect", {
  y: 3,
  width: 7,
  height: 1,
  rx: .5
}), h.createElement("rect", {
  transform: "rotate(90 3.5 3.5)",
  y: 3,
  width: 7,
  height: 1,
  rx: .5
})),
    wo = function wo(e) {
  return h.createElement("svg", yo({
    width: 9,
    height: 9
  }, e), ko);
};

w.extend(R);

var xo = 864e5,
    Eo = function (e) {
  function l() {
    var e;
    return n(this, l), e = r(this, i(l).call(this)), o(a(e), "toggleTimeRangeSelector", function () {
      e.setState(function (e) {
        return {
          showTimeRangeSelector: !e.showTimeRangeSelector
        };
      });
    }), o(a(e), "setBookmark", function () {
      var t = e.props,
          n = t.start,
          r = t.end,
          i = t.onBookmarkChange;
      null !== i && i(n, r);
    }), o(a(e), "onTimeRangeSelectorSubmit", function (t, n) {
      e.notifyChange(t, n), e.setState({
        showTimeRangeSelector: !1
      });
    }), o(a(e), "zoom", function (t) {
      var n,
          r,
          i = e.props,
          o = i.start,
          a = i.end,
          s = i.absoluteStart,
          l = i.absoluteEnd,
          u = Math.round(M(o, a)),
          c = "day";

      if ("in" === t) {
        n = [365, 32, 30, 7, 1];

        for (var d = 0; d < n.length; d += 1) {
          var h = n[d];

          if (u > h) {
            r = h;
            break;
          }
        }

        void 0 === r && (r = 23.9, c = "hour");
      } else if ("out" === t) {
        n = [1, 7, 30, 32, 365];

        for (var m = 0; m < n.length; m += 1) {
          var f = n[m];

          if (u < f) {
            r = f;
            break;
          }
        }

        if (void 0 === r) return void e.notifyChange(s, l);
      }

      var p = "hour" === c ? xo / 24 : xo,
          g = x(o) + (x(a) - x(o)) / 2,
          v = w(g - r * p / 2).startOf(c),
          b = v.add(r, c).toISOString(),
          _ = r * p,
          y = T(v.toISOString(), b, _, s, l),
          k = y.newStartClamped,
          E = y.newEndClamped;

      e.notifyChange(k, E);
    }), o(a(e), "notifyChange", function (t, n) {
      var r = e.props.onChange,
          i = E(t, n);
      r(t, n, i.humanizedStart, i.humanizedEnd);
    }), o(a(e), "onPlaybackTick", function (t, n) {
      e.notifyChange(t, n);
    }), e.toggleImmediate = function (t) {
      e.setState(function (e) {
        return {
          immediate: t
        };
      });
    }, e.interval = null, e.state = {
      immediate: !1,
      showTimeRangeSelector: !1,
      absoluteEnd: null
    }, e;
  }

  return t(l, m), s(l, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props,
          t = e.start,
          n = e.end;
      this.notifyChange(t, n);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.start,
          r = t.end,
          i = t.absoluteStart,
          o = t.bookmarkStart,
          a = t.bookmarkEnd,
          s = t.enablePlayback,
          l = this.state.immediate,
          c = this.state,
          d = c.showTimeRangeSelector,
          m = c.absoluteEnd,
          f = D(n, r),
          p = M(n, r) <= M(i, m) - 1,
          g = null != o && null != a,
          v = g && x(o) === x(n) && x(a) === x(r);
      return h.createElement(j.Provider, {
        value: {
          immediate: l,
          toggleImmediate: this.toggleImmediate
        }
      }, h.createElement("div", {
        className: P.Timebar
      }, s && h.createElement(uo, {
        start: n,
        end: r,
        absoluteStart: i,
        absoluteEnd: m,
        onTick: this.onPlaybackTick
      }), h.createElement("div", {
        className: P.timeActions
      }, d && h.createElement(ie, u({}, this.props, {
        absoluteEnd: m,
        onSubmit: this.onTimeRangeSelectorSubmit,
        onDiscard: this.toggleTimeRangeSelector
      })), h.createElement("div", {
        className: P.timeRangeContainer
      }, h.createElement("button", {
        type: "button",
        title: "Select a time range",
        className: N(P.uiButton, P.timeRange),
        onClick: this.toggleTimeRangeSelector
      }, h.createElement(mo, null))), h.createElement("button", {
        type: "button",
        title: "Bookmark current time range",
        className: N(P.uiButton, P.bookmark),
        onClick: this.setBookmark,
        disabled: !0 === v
      }, g ? h.createElement(hi, null) : h.createElement(go, null)), h.createElement("div", {
        className: P.timeScale
      }, h.createElement("button", {
        type: "button",
        title: "Zoom out",
        disabled: !1 === p,
        onClick: function onClick() {
          e.zoom("out");
        },
        className: N(P.uiButton, P.out)
      }, h.createElement(_o, null)), h.createElement("button", {
        type: "button",
        title: "Zoom in",
        disabled: !1 === f,
        onClick: function onClick() {
          e.zoom("in");
        },
        className: N(P.uiButton, P.in)
      }, h.createElement(wo, null)))), h.createElement(Li, u({}, this.props, {
        onChange: this.notifyChange,
        absoluteEnd: m
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function value(e) {
      return {
        absoluteEnd: w(e.absoluteEnd).endOf("day").toISOString()
      };
    }
  }]), l;
}();

Eo.propTypes = {
  start: p.string.isRequired,
  end: p.string.isRequired,
  bookmarkStart: p.string,
  bookmarkEnd: p.string,
  onBookmarkChange: p.func,
  onChange: p.func.isRequired,
  absoluteStart: p.string.isRequired,
  absoluteEnd: p.string.isRequired,
  enablePlayback: p.bool
}, Eo.defaultProps = {
  bookmarkStart: null,
  bookmarkEnd: null,
  enablePlayback: !1,
  onBookmarkChange: function onBookmarkChange() {}
};
var Mo = Math.PI,
    So = 2 * Mo,
    To = So - 1e-6;

function Co() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}

function Do() {
  return new Co();
}

function Ao(e) {
  return function () {
    return e;
  };
}

function Oo(e) {
  this._context = e;
}

function Fo(e) {
  return new Oo(e);
}

function Ro(e) {
  return e[0];
}

function No(e) {
  return e[1];
}

function jo() {
  var e = Ro,
      t = null,
      n = Ao(0),
      r = No,
      i = Ao(!0),
      o = null,
      a = Fo,
      s = null;

  function l(l) {
    var u,
        c,
        d,
        h,
        m,
        f = l.length,
        p = !1,
        g = new Array(f),
        v = new Array(f);

    for (null == o && (s = a(m = Do())), u = 0; u <= f; ++u) {
      if (!(u < f && i(h = l[u], u, l)) === p) if (p = !p) c = u, s.areaStart(), s.lineStart();else {
        for (s.lineEnd(), s.lineStart(), d = u - 1; d >= c; --d) {
          s.point(g[d], v[d]);
        }

        s.lineEnd(), s.areaEnd();
      }
      p && (g[u] = +e(h, u, l), v[u] = +n(h, u, l), s.point(t ? +t(h, u, l) : g[u], r ? +r(h, u, l) : v[u]));
    }

    if (m) return s = null, m + "" || null;
  }

  function u() {
    return function () {
      var e = Ro,
          t = No,
          n = Ao(!0),
          r = null,
          i = Fo,
          o = null;

      function a(a) {
        var s,
            l,
            u,
            c = a.length,
            d = !1;

        for (null == r && (o = i(u = Do())), s = 0; s <= c; ++s) {
          !(s < c && n(l = a[s], s, a)) === d && ((d = !d) ? o.lineStart() : o.lineEnd()), d && o.point(+e(l, s, a), +t(l, s, a));
        }

        if (u) return o = null, u + "" || null;
      }

      return a.x = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : Ao(+t), a) : e;
      }, a.y = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : Ao(+e), a) : t;
      }, a.defined = function (e) {
        return arguments.length ? (n = "function" == typeof e ? e : Ao(!!e), a) : n;
      }, a.curve = function (e) {
        return arguments.length ? (i = e, null != r && (o = i(r)), a) : i;
      }, a.context = function (e) {
        return arguments.length ? (null == e ? r = o = null : o = i(r = e), a) : r;
      }, a;
    }().defined(i).curve(a).context(o);
  }

  return l.x = function (n) {
    return arguments.length ? (e = "function" == typeof n ? n : Ao(+n), t = null, l) : e;
  }, l.x0 = function (t) {
    return arguments.length ? (e = "function" == typeof t ? t : Ao(+t), l) : e;
  }, l.x1 = function (e) {
    return arguments.length ? (t = null == e ? null : "function" == typeof e ? e : Ao(+e), l) : t;
  }, l.y = function (e) {
    return arguments.length ? (n = "function" == typeof e ? e : Ao(+e), r = null, l) : n;
  }, l.y0 = function (e) {
    return arguments.length ? (n = "function" == typeof e ? e : Ao(+e), l) : n;
  }, l.y1 = function (e) {
    return arguments.length ? (r = null == e ? null : "function" == typeof e ? e : Ao(+e), l) : r;
  }, l.lineX0 = l.lineY0 = function () {
    return u().x(e).y(n);
  }, l.lineY1 = function () {
    return u().x(e).y(r);
  }, l.lineX1 = function () {
    return u().x(t).y(n);
  }, l.defined = function (e) {
    return arguments.length ? (i = "function" == typeof e ? e : Ao(!!e), l) : i;
  }, l.curve = function (e) {
    return arguments.length ? (a = e, null != o && (s = a(o)), l) : a;
  }, l.context = function (e) {
    return arguments.length ? (null == e ? o = s = null : s = a(o = e), l) : o;
  }, l;
}

Co.prototype = Do.prototype = {
  constructor: Co,
  moveTo: function moveTo(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function closePath() {
    null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function lineTo(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function quadraticCurveTo(e, t, n, r) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function bezierCurveTo(e, t, n, r, i, o) {
    this._ += "C" + +e + "," + +t + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +o);
  },
  arcTo: function arcTo(e, t, n, r, i) {
    e = +e, t = +t, n = +n, r = +r, i = +i;
    var o = this._x1,
        a = this._y1,
        s = n - e,
        l = r - t,
        u = o - e,
        c = a - t,
        d = u * u + c * c;
    if (i < 0) throw new Error("negative radius: " + i);
    if (null === this._x1) this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);else if (d > 1e-6) {
      if (Math.abs(c * s - l * u) > 1e-6 && i) {
        var h = n - o,
            m = r - a,
            f = s * s + l * l,
            p = h * h + m * m,
            g = Math.sqrt(f),
            v = Math.sqrt(d),
            b = i * Math.tan((Mo - Math.acos((f + d - p) / (2 * g * v))) / 2),
            _ = b / v,
            y = b / g;

        Math.abs(_ - 1) > 1e-6 && (this._ += "L" + (e + _ * u) + "," + (t + _ * c)), this._ += "A" + i + "," + i + ",0,0," + +(c * h > u * m) + "," + (this._x1 = e + y * s) + "," + (this._y1 = t + y * l);
      } else this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
    } else ;
  },
  arc: function arc(e, t, n, r, i, o) {
    e = +e, t = +t, o = !!o;
    var a = (n = +n) * Math.cos(r),
        s = n * Math.sin(r),
        l = e + a,
        u = t + s,
        c = 1 ^ o,
        d = o ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    null === this._x1 ? this._ += "M" + l + "," + u : (Math.abs(this._x1 - l) > 1e-6 || Math.abs(this._y1 - u) > 1e-6) && (this._ += "L" + l + "," + u), n && (d < 0 && (d = d % So + So), d > To ? this._ += "A" + n + "," + n + ",0,1," + c + "," + (e - a) + "," + (t - s) + "A" + n + "," + n + ",0,1," + c + "," + (this._x1 = l) + "," + (this._y1 = u) : d > 1e-6 && (this._ += "A" + n + "," + n + ",0," + +(d >= Mo) + "," + c + "," + (this._x1 = e + n * Math.cos(i)) + "," + (this._y1 = t + n * Math.sin(i))));
  },
  rect: function rect(e, t, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function toString() {
    return this._;
  }
}, Oo.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;

      case 1:
        this._point = 2;

      default:
        this._context.lineTo(e, t);

    }
  }
};
var Po = Array.prototype.slice;

function zo(e) {
  return e < 0 ? -1 : 1;
}

function Uo(e, t, n) {
  var r = e._x1 - e._x0,
      i = t - e._x1,
      o = (e._y1 - e._y0) / (r || i < 0 && -0),
      a = (n - e._y1) / (i || r < 0 && -0),
      s = (o * i + a * r) / (r + i);
  return (zo(o) + zo(a)) * Math.min(Math.abs(o), Math.abs(a), .5 * Math.abs(s)) || 0;
}

function qo(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}

function Io(e, t, n) {
  var r = e._x0,
      i = e._y0,
      o = e._x1,
      a = e._y1,
      s = (o - r) / 3;

  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}

function Lo(e) {
  this._context = e;
}

function Ho(e) {
  this._context = e;
}

function Vo(e, t) {
  this._context = e, this._t = t;
}

function Xo(e) {
  return new Vo(e, 1);
}

function Bo(e, t) {
  if ((i = e.length) > 1) for (var n, r, i, o = 1, a = e[t[0]], s = a.length; o < i; ++o) {
    for (r = a, a = e[t[o]], n = 0; n < s; ++n) {
      a[n][1] += a[n][0] = isNaN(r[n][1]) ? r[n][0] : r[n][1];
    }
  }
}

function Wo(e) {
  for (var t = e.length, n = new Array(t); --t >= 0;) {
    n[t] = t;
  }

  return n;
}

function Yo(e, t) {
  return e[t];
}

function Go(e, t) {
  if ((n = e.length) > 0) {
    for (var n, r = 0, i = e[t[0]], o = i.length; r < o; ++r) {
      for (var a = 0, s = 0; a < n; ++a) {
        s += e[a][r][1] || 0;
      }

      i[r][1] += i[r][0] = -s / 2;
    }

    Bo(e, t);
  }
}

Lo.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);

        break;

      case 3:
        Io(this, this._t0, qo(this, this._t0));
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    var n = NaN;

    if (t = +t, (e = +e) !== this._x1 || t !== this._y1) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, Io(this, qo(this, n = Uo(this, e, t)), n);
          break;

        default:
          Io(this, this._t0, n = Uo(this, e, t));
      }

      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
}, (function (e) {
  this._context = new Ho(e);
}.prototype = Object.create(Lo.prototype)).point = function (e, t) {
  Lo.prototype.point.call(this, t, e);
}, Ho.prototype = {
  moveTo: function moveTo(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function closePath() {
    this._context.closePath();
  },
  lineTo: function lineTo(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function bezierCurveTo(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
}, Vo.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;

      case 1:
        this._point = 2;

      default:
        if (this._t <= 0) this._context.lineTo(this._x, t), this._context.lineTo(e, t);else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
    }

    this._x = e, this._y = t;
  }
};
var Zo = "activity-module_Activity__1Yf64";
k(".activity-module_Activity__1Yf64 path {\n  fill: var(--timebar-light-blue);\n}\n");

var $o = function (e) {
  function o() {
    return n(this, o), r(this, i(o).apply(this, arguments));
  }

  return t(o, m), s(o, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.activity,
          n = e.absoluteEnd,
          r = e.outerScale,
          i = e.outerWidth,
          o = e.graphHeight,
          a = this.context.immediate,
          s = t[t.length - 1],
          l = {
        date: x(n),
        value: s.value
      },
          u = o - 5 - 20,
          c = 5 + u / 2,
          m = jo().x(function (e) {
        return r(e.date);
      }).y0(function (e) {
        return c - u * e.value / 2;
      }).y1(function (e) {
        return c + u * e.value / 2;
      }).curve(Xo);
      return h.createElement("svg", {
        width: i,
        height: o,
        className: Zo
      }, h.createElement(Zr, {
        native: !0,
        immediate: a,
        to: {
          d: m([].concat(d(t), [l]))
        }
      }, function (e) {
        return h.createElement(Jr.path, {
          d: e.d,
          fill: "pink",
          fillOpacity: .9
        });
      }));
    }
  }]), o;
}();

o($o, "contextType", j), $o.propTypes = {
  activity: p.arrayOf(p.shape({
    id: p.string,
    date: p.number,
    value: p.number
  })).isRequired,
  absoluteEnd: p.string.isRequired,
  outerScale: p.func.isRequired,
  outerWidth: p.number.isRequired,
  graphHeight: p.number.isRequired
};
var Jo = {
  fishing: "events-module_fishing__6FAbu",
  port: "events-module_port__1RwCR",
  encounter: "events-module_encounter__2s6R3",
  unregistered: "events-module_unregistered__1JOmF",
  gap: "events-module_gap__z0xsT"
};
k("/* TODO Use variables */\n.events-module_fishing__6FAbu {\n  fill: #fe81eb;\n}\n\n.events-module_port__1RwCR {\n  fill: #44a1b9;\n}\n\n.events-module_encounter__2s6R3 {\n  fill: #e5647d;\n}\n\n.events-module_unregistered__1JOmF {\n  fill: #9a84ed;\n}\n\n.events-module_gap__z0xsT {\n  fill: #ffe7a0;\n}\n");

var Ko = function (e) {
  function l() {
    var e, t;
    n(this, l);

    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++) {
      u[h] = arguments[h];
    }

    return t = r(this, (e = i(l)).call.apply(e, [this].concat(u))), o(a(t), "getFinalEvents", Vi(function (e, t) {
      var n = e.series,
          r = n.labels,
          i = n.counts;

      if (!0 !== t) {
        var o = r.indexOf("fishing");
        r = [].concat(d(r.slice(0, o)), d(r.slice(o + 1))), i = [].concat(d(i.slice(0, o)), d(i.slice(o + 1)));
      }

      for (var a = e.offset, s = w(e.start), l = w(e.end), u = s.clone(), h = l.diff(s, a), m = [], f = 0, p = function p(e) {
        var t = 0,
            n = {
          date: u.toDate()
        };
        if (r.forEach(function (r, o) {
          var a = i[o][e];
          n[r] = a, t += a;
        }), r.map(function (e) {
          return n[e];
        }).filter(function (e) {
          return void 0 === e;
        }).length === r.length) return console.warn("there are no values after this date, aborting rendering", n), "break";
        t > f && (f = t), u = u.add(1, a), m.push(n);
      }, g = 0; g < h + 1; g += 1) {
        if ("break" === p(g)) break;
      }

      var v = [];
      return m.forEach(function (e) {
        var t = c({}, e);
        r.forEach(function (n) {
          t[n] = e[n] / f;
        }), v.push(t);
      }), v.push(c({}, v[v.length - 1], {
        date: u.toDate()
      })), function () {
        var e = Ao([]),
            t = Wo,
            n = Bo,
            r = Yo;

        function i(i) {
          var o,
              a,
              s = e.apply(this, arguments),
              l = i.length,
              u = s.length,
              c = new Array(u);

          for (o = 0; o < u; ++o) {
            for (var d, h = s[o], m = c[o] = new Array(l), f = 0; f < l; ++f) {
              m[f] = d = [0, +r(i[f], h, f, i)], d.data = i[f];
            }

            m.key = h;
          }

          for (o = 0, a = t(c); o < u; ++o) {
            c[a[o]].index = o;
          }

          return n(c, a), c;
        }

        return i.keys = function (t) {
          return arguments.length ? (e = "function" == typeof t ? t : Ao(Po.call(t)), i) : e;
        }, i.value = function (e) {
          return arguments.length ? (r = "function" == typeof e ? e : Ao(+e), i) : r;
        }, i.order = function (e) {
          return arguments.length ? (t = null == e ? Wo : "function" == typeof e ? e : Ao(Po.call(e)), i) : t;
        }, i.offset = function (e) {
          return arguments.length ? (n = null == e ? Bo : e, i) : n;
        }, i;
      }().keys(r).order(Wo).offset(Go)(v);
    })), t;
  }

  return t(l, m), s(l, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.events,
          n = e.outerScale,
          r = e.outerWidth,
          i = e.graphHeight,
          o = e.showFishing,
          a = this.getFinalEvents(t, o),
          s = i - 5 - 20,
          l = 5 + s / 2,
          u = jo().x(function (e) {
        return n(e.data.date);
      }).y0(function (e) {
        return l + s * e[0];
      }).y1(function (e) {
        return l + s * e[1];
      }).curve(Xo);
      return h.createElement("svg", {
        width: r,
        height: i,
        className: Jo.Events
      }, a.map(function (e, t) {
        return h.createElement("path", {
          key: e.key + t,
          d: u(e),
          className: Jo[e.key]
        });
      }));
    }
  }]), l;
}();

Ko.propTypes = {
  events: p.shape({
    start: p.string,
    end: p.string,
    offset: p.string,
    series: p.shape({
      labels: p.arrayOf(p.string),
      counts: p.arrayOf(p.arrayOf(p.number))
    })
  }).isRequired,
  outerScale: p.func.isRequired,
  outerWidth: p.number.isRequired,
  graphHeight: p.number.isRequired,
  showFishing: p.bool
}, Ko.defaultProps = {
  showFishing: !1
};
var Qo = {
  Events: "vessel-events-module_Events__3bq6R",
  overlays: "vessel-events-module_overlays__1XJEc",
  backgrounds: "vessel-events-module_backgrounds__DM1UM",
  encounter: "vessel-events-module_encounter__1SorA",
  gap: "vessel-events-module_gap__2UnYC",
  fishing: "vessel-events-module_fishing__2PtDJ",
  port: "vessel-events-module_port__G8lru",
  _highlighted: "vessel-events-module__highlighted__2GFf0",
  lines: "vessel-events-module_lines__lXgbG",
  portBg: "vessel-events-module_portBg__2pfme",
  tooltip: "vessel-events-module_tooltip__bK5Dk",
  tooltipText: "vessel-events-module_tooltipText__3sxLM",
  tooltipDate: "vessel-events-module_tooltipDate__1Zsdc"
};

function ea() {
  return (ea = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

k(":root {\n  --timebar-encounter-color: #e5647d;\n  --timebar-gap-color: #ffe7a0;\n  --timebar-gap-color-darker: #ffbf00;\n  --timebar-fishing-color: #fe81eb;\n  --timebar-unregistered-color: #9a84ed;\n  --timebar-port-color: #44a1b9;\n}\n\n.vessel-events-module_Events__3bq6R {\n  position: absolute;\n}\n\n.vessel-events-module_overlays__1XJEc rect,\n.vessel-events-module_backgrounds__DM1UM rect {\n  cursor: pointer;\n}\n\n.vessel-events-module_overlays__1XJEc rect {\n  stroke: var(--timebar-main-background-color);\n  stroke-width: 1px;\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module_encounter__1SorA rect {\n  fill: var(--timebar-encounter-color);\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module_gap__2UnYC rect {\n  fill: var(--timebar-gap-color);\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module_fishing__2PtDJ rect {\n  fill: var(--timebar-fishing-color);\n  stroke: none;\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module_port__G8lru rect {\n  fill: var(--timebar-main-background-color);\n  stroke: var(--timebar-fishing-color);\n  stroke-width: 2px;\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module__highlighted__2GFf0 rect {\n  stroke: var(--timebar-white);\n  stroke-width: 2px;\n}\n\n.vessel-events-module_backgrounds__DM1UM .vessel-events-module_port__G8lru rect {\n  fill: var(--timebar-main-background-color-white);\n}\n\n.vessel-events-module_overlays__1XJEc .vessel-events-module_port__G8lru.vessel-events-module__highlighted__2GFf0 rect {\n  stroke: var(--timebar-white);\n}\n\n.vessel-events-module_lines__lXgbG line {\n  stroke: var(--timebar-fishing-color);\n  stroke-width: 2px;\n}\n\n.vessel-events-module_lines__lXgbG line.vessel-events-module_port__G8lru {\n  stroke-dasharray: 4;\n  stroke-linecap: butt;\n}\n\n.vessel-events-module_lines__lXgbG line.vessel-events-module_portBg__2pfme {\n  stroke: var(--timebar-main-background-color-white-overlay);\n}\n\n.vessel-events-module_backgrounds__DM1UM .vessel-events-module_port__G8lru.vessel-events-module__highlighted__2GFf0 rect {\n  fill: var(--timebar-white);\n  fill-opacity: 0.2;\n}\n\n.vessel-events-module_tooltip__bK5Dk {\n  background: var(--timebar-white);\n  position: absolute;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  color: var(--timebar-main-background-color);\n  padding: 6px 8px;\n  transform: translate(-50%, -100%);\n  top: 10px;\n  z-index: 10;\n  font-weight: normal;\n}\n\n.vessel-events-module_tooltip__bK5Dk::after {\n  background: var(--timebar-white);\n  content: ' ';\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  left: calc(50% - 2px);\n  transform: rotate(45deg);\n  bottom: -5px;\n}\n\n.vessel-events-module_tooltipText__3sxLM {\n  margin-left: 10px;\n}\n\n.vessel-events-module_tooltipDate__1Zsdc {\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_encounter__1SorA .vessel-events-module_tooltipDate__1Zsdc {\n  color: var(--timebar-encounter-color);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_encounter__1SorA svg {\n  fill: var(--timebar-encounter-color);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_gap__2UnYC .vessel-events-module_tooltipDate__1Zsdc {\n  color: var(--timebar-gap-color-darker);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_gap__2UnYC svg {\n  fill: var(--timebar-gap-color-darker);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_fishing__2PtDJ .vessel-events-module_tooltipDate__1Zsdc {\n  color: var(--timebar-fishing-color);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_port__G8lru .vessel-events-module_tooltipDate__1Zsdc {\n  color: var(--timebar-port-color);\n}\n\n.vessel-events-module_tooltip__bK5Dk.vessel-events-module_port__G8lru svg {\n  stroke: var(--timebar-port-color);\n}\n");
var ta = h.createElement("path", {
  fillRule: "evenodd",
  d: "M11 6.82L7.68 3.5 11 .18v2.5h5.82v1.64H11v2.5zm-5 .86v-2.5L9.32 8.5 6 11.82v-2.5H.18V7.68H6z"
});

function na() {
  return (na = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var ra = h.createElement("path", {
  fillRule: "evenodd",
  d: "M6.66 11.69c1.27 0 2.35-.45 3.24-1.33a4.39 4.39 0 001.33-3.22c0-1.27-.45-2.34-1.33-3.23A4.39 4.39 0 006.68 2.6c-1.27 0-2.34.44-3.23 1.32a4.39 4.39 0 00-1.33 3.23c0 1.26.45 2.33 1.33 3.22a4.37 4.37 0 003.2 1.33zm0-10.4c1.61 0 3 .58 4.14 1.73a5.64 5.64 0 011.72 4.14c0 1.61-.58 2.98-1.72 4.1a5.71 5.71 0 01-4.14 1.68 5.58 5.58 0 01-4.1-1.68 5.58 5.58 0 01-1.69-4.1c0-1.62.56-3 1.68-4.14a5.52 5.52 0 014.1-1.72zM.02 3.8V.49h3.32L.02 3.8zm3.32 10H.02v-3.31l3.32 3.32zm10-3.31v3.32h-3.32l3.32-3.32zm-3.32-10h3.32V3.8L10.02.48z"
});

function ia() {
  return (ia = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var oa = h.createElement("path", {
  fillRule: "evenodd",
  d: "M11.7 13.15L4.35 5.8A5.18 5.18 0 003.26 9c0 1.45.51 2.69 1.53 3.7a5.05 5.05 0 003.71 1.54c1.17 0 2.24-.36 3.2-1.1zM1.75 3.2l.95-.95L15.25 14.8l-.95.95-1.55-1.55a6.56 6.56 0 01-3.51 1.51v1.55H7.76v-1.55a6.52 6.52 0 01-4.04-1.93 6.52 6.52 0 01-1.93-4.04H.24V8.26h1.55a6.56 6.56 0 011.5-3.51L1.76 3.2zm13.46 5.06h1.55v1.48h-1.55a6.66 6.66 0 01-.73 2.39L13.35 11c.26-.63.39-1.3.39-2 0-1.45-.51-2.69-1.53-3.7A5.05 5.05 0 008.5 3.75c-.7 0-1.37.13-2 .39L5.37 3.02a7.3 7.3 0 012.4-.73V.74h1.47v1.55c1.57.16 2.92.8 4.04 1.93a6.52 6.52 0 011.93 4.04z"
});

function aa() {
  return (aa = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var sa = h.createElement("g", {
  fill: "none",
  transform: "translate(.5 1)"
}, h.createElement("circle", {
  cx: 7,
  cy: 2,
  r: 2
}), h.createElement("path", {
  d: "M1.46 9.3a6 6 0 0011.08 0"
}), h.createElement("path", {
  fill: "#44A1B9",
  d: "M10 8h4v4zM4 8H0v4z"
}), h.createElement("path", {
  d: "M7 4.61v7.89"
})),
    la = {
  encounter: h.createElement(function (e) {
    return h.createElement("svg", ea({
      width: 17,
      height: 12
    }, e), ta);
  }, null),
  unregistered: h.createElement(function (e) {
    return h.createElement("svg", na({
      width: 14,
      height: 14
    }, e), ra);
  }, null),
  gap: h.createElement(function (e) {
    return h.createElement("svg", ia({
      width: 17,
      height: 18
    }, e), oa);
  }, null),
  port: h.createElement(function (e) {
    return h.createElement("svg", aa({
      width: 15,
      height: 15
    }, e), sa);
  }, null),
  fishing: null
},
    ua = {
  port: 6,
  fishing: 5,
  gap: 8,
  encounter: 8
},
    ca = h.memo(function (e) {
  var t = e.outerScale,
      n = e.events,
      r = e.y,
      i = e.className,
      o = e.children;
  return h.createElement("g", {
    transform: "translate(0, ".concat(r, ")"),
    className: i
  }, n.map(function (e) {
    var n = ua[e.type],
        r = t(e.start),
        i = null === e.end ? r : t(e.end),
        a = Math.max(n, i - r);
    return o({
      style: {
        x1: r,
        x2: i,
        width: a
      },
      event: e,
      height: n
    });
  }));
});
ca.propTypes = {
  outerScale: p.func.isRequired,
  events: p.arrayOf(p.shape({
    start: p.instanceOf(Date),
    end: p.instanceOf(Date)
  })).isRequired,
  children: p.func.isRequired,
  y: p.number.isRequired,
  className: p.string.isRequired
};

var da = function (e) {
  function l() {
    var e, t;
    n(this, l);

    for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++) {
      u[h] = arguments[h];
    }

    return t = r(this, (e = i(l)).call.apply(e, [this].concat(u))), o(a(t), "getEvents", Vi(function (e) {
      return e.map(function (e) {
        return c({}, e, {
          start: new Date(e.start),
          end: null === e.end ? null : new Date(e.end)
        });
      });
    })), o(a(t), "addHighlightInfo", Vi(function (e, t, n) {
      var r = e.map(function (e) {
        var r = null !== t && t.indexOf(e.id) > -1 || null !== n && n === e.id;
        return c({}, e, {
          isHighlighted: r
        });
      });
      return [].concat(d(r.filter(function (e) {
        return !1 === e.isHighlighted;
      })), d(r.filter(function (e) {
        return !0 === e.isHighlighted;
      })));
    })), o(a(t), "filterEvents", Vi(function (e, t, n) {
      var r = e;
      return w(n).diff(w(t), "day") > 365 && (r = e.filter(function (e) {
        return "fishing" !== e.type;
      })), r;
    })), o(a(t), "getBackgrounds", Vi(function (e) {
      return e.filter(function (e) {
        return null !== e.end;
      }).filter(function (e) {
        return "port" === e.type;
      });
    })), o(a(t), "getLines", Vi(function (e) {
      var t = e.filter(function (e) {
        return null !== e.end;
      }).filter(function (e) {
        return ["port", "track"].includes(e.type);
      });
      return t.filter(function (e) {
        return "port" === e.type;
      }).forEach(function (e) {
        t.push(c({}, e, {
          type: "portBg",
          id: "".concat(e.id, "-bg")
        }));
      }), (t = t.map(function (e) {
        return c({}, e, {
          order: ["track", "portBg", "port"].indexOf(e.type)
        });
      })).sort(function (e, t) {
        return e.order - t.order;
      }), t;
    })), o(a(t), "getOverlays", Vi(function (e) {
      var t = [];
      return e.filter(function (e) {
        return ["port", "encounter", "gap", "fishing"].includes(e.type);
      }).forEach(function (e) {
        var n = c({}, e);
        "port" === e.type && (null === e.end ? n.interactive = !0 : (t.push(c({}, n, {
          start: n.end,
          uid: "".concat(n.id, "-end}")
        })), n.end = n.start)), t.push(n);
      }), t.sort(function (e, t) {
        return "fishing" === e.type && "fishing" !== t.type ? -1 : "fishing" !== e.type && "fishing" === t.type ? 1 : 0;
      }), t;
    })), t;
  }

  return t(l, m), s(l, [{
    key: "renderTooltip",
    value: function value(e) {
      var t = this.props,
          n = t.highlightedEventIDs,
          r = t.outerScale;
      if (null === n || 1 !== n.length) return null;
      var i = e.find(function (e) {
        return e.id === n[0];
      });
      if (void 0 === i) return null;
      var o,
          a = r(i.start),
          s = a + (null === i.end || void 0 === i ? 0 : r(i.end) - a) / 2,
          l = w(i.start),
          u = i.end ? l.from(w(i.end), !0) : null;

      switch (i.type) {
        case "fishing":
          o = "Fished (".concat(u, ")");
          break;

        case "gap":
          o = "Tracking avoidance (".concat(u, ")");
          break;

        case "encounter":
          var c = i.encounter.vessel,
              d = c && (c.name || c.ssvid || c.id);
          o = null == d ? "Had encounter with unnamed vessel" : "Had encounter with ".concat(d), o = "".concat(o, " (").concat(u, ")");
          break;

        case "port":
          var m = i.port.name;
          o = null === m ? "Docked" : "Docked at ".concat(m), o = "".concat(o, " (").concat(u, ")");
      }

      return h.createElement("div", {
        className: N(Qo.tooltip, Qo[i.type]),
        style: {
          left: s
        },
        key: "tooltip"
      }, la[i.type], h.createElement("div", {
        className: Qo.tooltipText
      }, h.createElement("div", {
        className: Qo.tooltipDate
      }, l.format("MMM D YYYY h:mm a")), o));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.events,
          n = e.selectedEventID,
          r = e.highlightedEventIDs,
          i = e.outerStart,
          a = e.outerEnd,
          s = e.outerWidth,
          l = e.graphHeight,
          c = e.onEventClick,
          d = e.onEventHighlighted,
          m = e.tooltipContainer,
          p = this.addHighlightInfo(this.getEvents(t), r, n),
          g = this.filterEvents(p, i, a),
          v = this.getBackgrounds(g),
          b = this.getLines(g),
          _ = this.getOverlays(g),
          y = l / 2,
          k = this.renderTooltip(g);

      return h.createElement(f, null, h.createElement("svg", {
        width: s,
        height: l,
        className: Qo.Events,
        key: "svg"
      }, h.createElement(ca, u({}, this.props, {
        events: v,
        className: Qo.backgrounds,
        y: 0
      }), function (e) {
        return h.createElement("g", {
          key: e.event.id,
          className: N(Qo[e.event.type], o({}, Qo._highlighted, e.event.isHighlighted)),
          onMouseEnter: function onMouseEnter() {
            return d(e.event);
          },
          onMouseLeave: function onMouseLeave() {
            return d();
          }
        }, h.createElement("rect", {
          x: e.style.x1 + ua.port / 2,
          y: 0,
          width: e.style.width,
          height: l
        }));
      }), h.createElement(ca, u({}, this.props, {
        events: b,
        className: Qo.lines,
        y: y
      }), function (e) {
        return h.createElement("line", {
          key: e.event.id,
          className: Qo[e.event.type],
          y: 0,
          x1: e.style.x1,
          x2: e.style.x2
        });
      }), h.createElement(ca, u({}, this.props, {
        events: _,
        className: Qo.overlays,
        y: y
      }), function (e) {
        return h.createElement("g", {
          className: N(Qo[e.event.type], o({}, Qo._highlighted, e.event.isHighlighted)),
          key: e.event.uid || e.event.id,
          onMouseEnter: function onMouseEnter() {
            return d(e.event);
          },
          onMouseLeave: function onMouseLeave() {
            return d();
          },
          onClick: function onClick() {
            return c(e.event);
          }
        }, h.createElement("rect", {
          className: "vessel-event -".concat(e.event.type),
          x: e.style.x1,
          y: -e.height / 2,
          width: e.style.width,
          height: e.height,
          rx: e.height / 2,
          ry: e.height / 2,
          fillOpacity: e.style.fillOpacity
        }));
      })), m && F.createPortal(k, m));
    }
  }]), l;
}();

da.propTypes = {
  events: p.arrayOf(p.shape({
    start: p.string,
    end: p.string,
    id: p.string,
    type: p.string
  })).isRequired,
  outerStart: p.string.isRequired,
  outerEnd: p.string.isRequired,
  selectedEventID: p.string,
  highlightedEventIDs: p.arrayOf(p.string),
  outerScale: p.func.isRequired,
  onEventHighlighted: p.func,
  onEventClick: p.func,
  outerWidth: p.number.isRequired,
  outerHeight: p.number.isRequired,
  graphHeight: p.number.isRequired,
  tooltipContainer: p.instanceOf(Element)
}, da.defaultProps = {
  selectedEventID: null,
  highlightedEventIDs: null,
  onEventHighlighted: function onEventHighlighted() {},
  onEventClick: function onEventClick() {},
  tooltipContainer: null
};
export { $o as A, Ko as E, Eo as T, da as V };